import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
  USCurrency: any;
  /**
   * Upload - https://www.apollographql.com/docs/apollo-server/data/file-uploads/
   * See example https://github.com/xometry/payment-file-service/pull/3
   */
  Upload: any;
};

export type AccessControl = {
  __typename?: 'AccessControl';
  policies: Maybe<Array<Maybe<AccessControlPolicy>>>;
};

export type AccessControlPolicy = {
  __typename?: 'AccessControlPolicy';
  context: Context;
  permissions: Array<Maybe<Permission>>;
};

export type AddTaxExemptionInput = {
  /** ID of the customer associated with the TaxExemption */
  billingAccountId: Scalars['String'];
};

export type ApplicationUser = {
  __typename?: 'ApplicationUser';
  /** The name of the application - e.g., "thomas", "xometry", etc. */
  application: Scalars['String'];
  /** The Federated Identity Id of the user */
  federatedIdentityId: Maybe<Scalars['Int']>;
  /** The user's ID in the application */
  userId: Scalars['ID'];
};

/** Auth Payments Return Type */
export type AuthPaymentReturn = {
  __typename?: 'AuthPaymentReturn';
  /** Human readable error message. Will only be populated if error is present */
  error: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  /** Was the auth payment successful */
  successful: Scalars['Boolean'];
};

/** Authorization Type for payment auths */
export type Authorization = {
  __typename?: 'Authorization';
  /** Amount the authorization is for */
  amount: Scalars['Int'];
  /** Checkout identifier (<entity_prefix>-<uuid>) in the context of a checkout interaction. */
  checkoutIdentifier: Maybe<Scalars['String']>;
  /** Date the auth was created */
  createdAt: Maybe<Scalars['Date']>;
  /** Date that the auth was deleted at */
  deletedAt: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  /** Authorization identifier in the context of the payment provider, e.g. auth_999999999 in strip */
  identifier: Scalars['String'];
  /** Stripe Card, MSTS Account Id, or Users PartnerId */
  methodId: Scalars['String'];
  /** payment provider type, e.g. Stripe or MSTS */
  methodType: Scalars['String'];
  /** The payment method associated with this auth */
  paymentMethod: Maybe<PaymentMethod>;
  /** Was the authorization successful */
  successful: Maybe<Scalars['Boolean']>;
  /** The latest updated date for this auth */
  updatedAt: Maybe<Scalars['Date']>;
  /** User id associated with the auth */
  userId: Scalars['String'];
};

export type AvailableBalance = PaymentMethodInterface & {
  __typename?: 'AvailableBalance';
  /** Credit amount available */
  availableBalance: Scalars['Int'];
  /** PartnerId of the user tied to this payment authorization or capture. */
  id: Scalars['ID'];
  /** 'availablebalance' */
  type: Scalars['String'];
};

/** Bank Account Details */
export type BankAccount = PaymentMethodInterface & {
  __typename?: 'BankAccount';
  /** Name of acount holder */
  accountHolderName: Scalars['String'];
  /** Bank Name */
  bankName: Scalars['String'];
  /** Primary Id */
  id: Scalars['ID'];
  /** The last 4 digits of the account number */
  last4: Scalars['String'];
  /** The status of the bank account in Stripe */
  status: Scalars['String'];
  /** 'bankaccount' */
  type: Scalars['String'];
};

/** This class represents a billing account - grouping of users for sake of unified accounting management */
export type BillingAccount = {
  __typename?: 'BillingAccount';
  /** Type of billing account, currently either Credit Account or Blanket PO */
  accountType: Maybe<BillingAccountType>;
  /** Per-billing account email address for accounts payable */
  apEmailAddress: Maybe<Scalars['String']>;
  /** Available credit (in cents) after balance refactor, credit limit - balance */
  availableCreditInCents: Maybe<Scalars['Int']>;
  /** Balance (in cents) - this is the original way balance was tracked, with delayed syncs from Intacct (currently used for checkout) */
  balanceInCents: Scalars['Int'];
  /** The account payable address in orders paid by this billing account */
  contact: Maybe<BillingAccountContact>;
  /** Creation datestamp */
  createdAt: Maybe<Scalars['DateTime']>;
  /** ID of User who created the Billing Account */
  createdBy: Maybe<Scalars['String']>;
  /** Credit limit (in cents) */
  creditLimitInCents: Scalars['Int'];
  /** List of credit memos (AR adjustments) from Intacct associated with this billing account */
  creditMemos: Maybe<Array<IntacctCreditMemo>>;
  /** Credit term of Billing Account - N30, N45, N60, etc. */
  creditTerm: Maybe<Scalars['String']>;
  /** Duns number */
  dunsNumber: Maybe<Scalars['String']>;
  /** History of Tracked Events */
  events: Maybe<Array<Maybe<BillingAccountEvent>>>;
  /** A human readable id in the form of a BILLING_ACCOUNT_ID_DIGITS digit hexadecimal number */
  id: Scalars['String'];
  /** List of invoices from Intacct associated with this billing account */
  invoices: Array<IntacctInvoice>;
  /** Billing Account name */
  name: Scalars['String'];
  /** Freeform notes on the billing account */
  notes: Maybe<Array<Maybe<BillingAccountNote>>>;
  /** Associated organization */
  organization: Maybe<BillingOrganization>;
  /** List of payments from Intacct associated with this billing account */
  payments: Array<IntacctPayment>;
  /** The url staff can use to pay invoices */
  portalUrl: Maybe<Scalars['String']>;
  /** The email staff can reference to for invoice inqueries */
  queryEmail: Maybe<Scalars['String']>;
  /** Current billing account status */
  status: Maybe<BillingAccountStatus>;
  /** Current balance (in cents) - this is after the refactor to calculate the balance in a more dynamic way */
  totalBalanceInCents: Scalars['Int'];
  /** Modification datestamp */
  updatedAt: Maybe<Scalars['DateTime']>;
  /** List of users who have privileges with the billing account */
  users: Maybe<Array<User>>;
};

export type BillingAccountAddress = {
  __typename?: 'BillingAccountAddress';
  /** The name of the city. */
  city: Scalars['String'];
  /** The (unabbreviated) name of the country. */
  country: Scalars['String'];
  /** The name of the Canadian province, if address is in Canada. */
  province: Maybe<Scalars['String']>;
  /** The name of the US state, if address is in the US. */
  state: Maybe<Scalars['String']>;
  /** The first line of the street address. */
  street1: Scalars['String'];
  /** The second line of the street address, if any. */
  street2: Maybe<Scalars['String']>;
  /** The postal or zipcode. */
  zipcode: Maybe<Scalars['String']>;
};

export type BillingAccountAddressInput = {
  /** The name of the city. */
  city: Scalars['String'];
  /** The (unabbreviated) name of the country. */
  country: Scalars['String'];
  /** The name of the Canadian province, if address is in Canada. */
  province: InputMaybe<Scalars['String']>;
  /** The name of the US state, if address is in the US. */
  state: InputMaybe<Scalars['String']>;
  /** The first line of the street address. */
  street1: Scalars['String'];
  /** The second line of the street address, if any. */
  street2: InputMaybe<Scalars['String']>;
  /** The postal or zipcode. */
  zipcode: InputMaybe<Scalars['String']>;
};

/** Billing contact (account payable) associated with billing account */
export type BillingAccountContact = {
  __typename?: 'BillingAccountContact';
  /** The physical address associated with the billing contact */
  address: Maybe<BillingAccountAddress>;
  /** The email address associated with the billing contact. This is also 'Account Payable' email */
  emailAddress: Scalars['String'];
  /** The billing contact's name as a single string (first name and last name) */
  name: Scalars['String'];
  /** The phone number associated with the billing contact */
  phoneNumber: Scalars['String'];
};

export type BillingAccountContactInput = {
  /** The physical address associated with the billing contact */
  address: InputMaybe<BillingAccountAddressInput>;
  /** The email address associated with the billing contact. This is also 'Account Payable' email */
  emailAddress: Scalars['String'];
  /** The billing contact's name as a single string (first name and last name) */
  name: Scalars['String'];
  /** The phone number associated with the billing contact */
  phoneNumber: Scalars['String'];
};

export type BillingAccountEdge = Edge & {
  __typename?: 'BillingAccountEdge';
  cursor: Scalars['String'];
  node: Maybe<BillingAccount>;
};

export type BillingAccountEvent = {
  __typename?: 'BillingAccountEvent';
  /** ID of user who is responsible for the event */
  actorId: Scalars['String'];
  /** Display Name of User responsible for the event */
  actorName: Maybe<Scalars['String']>;
  /** JSON object for any optionally needed data */
  data: Maybe<Scalars['String']>;
  /**
   * JSON Stringified version of data field
   * Example:
   * {
   *   userId: 'E1304',
   *   userName: 'Test Person',
   *   reason: 'User no longer part of team'
   * }
   */
  dataJsonString: Maybe<Scalars['String']>;
  /** Datestamp of when Event occurred */
  eventDate: Maybe<Scalars['DateTime']>;
  /** ID of the Event */
  id: Scalars['String'];
  /** Summary of event */
  summaryText: Maybe<Scalars['String']>;
  /** Type of event */
  type: Scalars['String'];
};

export type BillingAccountNote = {
  __typename?: 'BillingAccountNote';
  /** Author of the note */
  author: Maybe<User>;
  /** UserID of the authoring user */
  authorId: Maybe<Scalars['String']>;
  /** ID of the billing account to which this note belongs */
  billingAccountId: Scalars['ID'];
  /** Note contents */
  content: Maybe<Scalars['String']>;
  /** Creation datestamp */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Modification datestamp */
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum BillingAccountStatus {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED'
}

export enum BillingAccountType {
  BlanketPo = 'Blanket_PO',
  CreditAccount = 'Credit_Account'
}

export type BillingAccountsConnection = {
  __typename?: 'BillingAccountsConnection';
  edges: Maybe<Array<Maybe<BillingAccountEdge>>>;
  pageInfo: Maybe<PageInfo>;
};

export type BillingOrganization = {
  __typename?: 'BillingOrganization';
  /** Billing Accounts */
  billingAccounts: Maybe<Array<Maybe<BillingAccount>>>;
  /** Creation datestamp */
  createdAt: Maybe<Scalars['DateTime']>;
  /** ID of the organization */
  id: Scalars['String'];
  /** Billing organization name */
  name: Maybe<Scalars['String']>;
  /** Modification datestamp */
  updatedAt: Maybe<Scalars['DateTime']>;
};

/** Describes the users payment method and amount chossen during a checkout */
export type BuyerCheckoutSelection = {
  __typename?: 'BuyerCheckoutSelection';
  /** Amount the checkout is for */
  amount: Scalars['Int'];
  checkoutIdentifier: Scalars['String'];
  /** Date this */
  createdAt: Maybe<Scalars['Date']>;
  deletedAt: Maybe<Scalars['Date']>;
  /** Stripe Card or MSTS Account Id */
  methodId: Scalars['String'];
  /** payment provider type, e.g. Stripe or MSTS */
  methodType: Scalars['String'];
  paymentMethod: Maybe<PaymentMethod>;
  /** User id who generated this checkout Configuration. */
  userId: Scalars['String'];
};

export type BuyerCheckoutSelectionMutationResponse = MutationResponse & {
  __typename?: 'BuyerCheckoutSelectionMutationResponse';
  buyerCheckoutSelection: Maybe<BuyerCheckoutSelection>;
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Capture = {
  __typename?: 'Capture';
  /** Amount the authorization is for */
  amount: Scalars['Int'];
  /** Checkout identifier (<entity_prefix>-<uuid>) in the context of a checkout interaction. */
  checkoutIdentifier: Maybe<Scalars['String']>;
  /** Date the caputre was created */
  createdAt: Maybe<Scalars['Date']>;
  /** Date that the capture was deleted at */
  deletedAt: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  /** Capture identifier in the context of the payment provider, e.g. ch_* in strip */
  identifier: Scalars['String'];
  /** Stripe Card, MSTS Account Id, or Users PartnerId */
  methodId: Scalars['String'];
  /** payment provider type, e.g. Stripe or MSTS */
  methodType: Scalars['String'];
  /** The payment method associated with this capture */
  paymentMethod: Maybe<PaymentMethod>;
  /** Was the capture successful */
  successful: Maybe<Scalars['Boolean']>;
  /** The latest updated date for this capture */
  updatedAt: Maybe<Scalars['Date']>;
  /** User id associated with the capture */
  userId: Scalars['String'];
};

/** Capture Payment Return Type */
export type CapturePaymentReturn = {
  __typename?: 'CapturePaymentReturn';
  /** Human readable error message. Will only be populated if error is present */
  error: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  /** Was the auth payment successful */
  successful: Scalars['Boolean'];
};

/** Filters by any of these fields */
export type CapturesFilters = {
  /** Checkout Identifier (<entity_prefix>-<uuid>) Used to coorelate this capture with a checkout experience */
  checkoutIdentifier: InputMaybe<Scalars['String']>;
  /** payment provider type, e.g. Stripe or MSTS or Available Balance */
  paymentMethodType: InputMaybe<Scalars['String']>;
  /** Was the capture successful */
  successful: InputMaybe<Scalars['Boolean']>;
  /** User id associated with the capture */
  userId: InputMaybe<Scalars['String']>;
};

export type CertCaptureId = {
  /** Id for tax code or exposure zone objects. ID only. */
  id: InputMaybe<Scalars['ID']>;
};

export type CheckoutPaymentReturn = {
  __typename?: 'CheckoutPaymentReturn';
  /** Human readable error message. Will only be populated if error is present */
  error: Maybe<Scalars['String']>;
  /** authorization or capture id */
  id: Maybe<Scalars['Int']>;
  /** Was the auth payment successful */
  successful: Scalars['Boolean'];
};

export type Connection = {
  edges: Maybe<Array<Maybe<Edge>>>;
  pageInfo: Maybe<PageInfo>;
};

export enum Context {
  Account = 'ACCOUNT',
  User = 'USER'
}

export type ContextInput = {
  context: Context;
};

export type CreateBillingAccountInput = {
  contact: BillingAccountContactInput;
  createdBy: InputMaybe<Scalars['String']>;
  isCustomer: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type CreateBillingAccountResult = {
  __typename?: 'CreateBillingAccountResult';
  billingAccount: BillingAccount;
};

export type CreateCreditApplicationFilesInput = {
  id: Scalars['Int'];
};

export type CreateCreditApplicationInput = {
  acctsPayableEmail: Scalars['String'];
  acctsPayablePhone: Scalars['String'];
  applicantName: Scalars['String'];
  applicantTitle: Scalars['String'];
  authorizedEmails: Scalars['String'];
  billingAccountId: Scalars['String'];
  city: Scalars['String'];
  date: Scalars['DateTime'];
  duns: Scalars['String'];
  entityName: Scalars['String'];
  files: Array<InputMaybe<CreateCreditApplicationFilesInput>>;
  financialDocs: Scalars['Boolean'];
  invoiceEmail: Scalars['String'];
  multiplePurchaseOrders: Scalars['Boolean'];
  purchaseOrderAmount: Scalars['Int'];
  requestedCreditLimit: Scalars['Int'];
  requestedTermLimit: Scalars['Int'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2: Scalars['String'];
  taxId: Scalars['String'];
  userId: Scalars['String'];
  zipcode: Scalars['String'];
};

/**
 * Only necessary fields for the frontend to display the result of the credit application.
 * We do not want extra data (DNB result, decisionReason, etc.) leaking to any snooping customers.
 */
export type CreateCreditApplicationResponse = {
  __typename?: 'CreateCreditApplicationResponse';
  acctsPayableEmail: Maybe<Scalars['String']>;
  acctsPayablePhone: Maybe<Scalars['String']>;
  applicantName: Maybe<Scalars['String']>;
  applicantTitle: Maybe<Scalars['String']>;
  /** In Pennies. Used for displaying what customer was approved for. */
  approvedAmount: Maybe<Scalars['Int']>;
  authorizedEmails: Maybe<Array<Maybe<Scalars['String']>>>;
  billingAccountId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  date: Maybe<Scalars['DateTime']>;
  decision: Maybe<Scalars['String']>;
  entityName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  invoiceEmail: Maybe<Scalars['String']>;
  multiplePurchaseOrders: Maybe<Scalars['Boolean']>;
  /** Expected in pennies */
  purchaseOrderAmount: Maybe<Scalars['Int']>;
  /** Expected in pennies */
  requestedCreditLimit: Maybe<Scalars['Int']>;
  requestedTermLimit: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  userId: Maybe<Scalars['String']>;
};

export type DeleteTaxExemptionInput = {
  /** ID of the customer associated with the TaxExemption */
  billingAccountId: Scalars['String'];
  /** ID of the TaxExemption to be deleted */
  taxExemptionId: Scalars['String'];
};

export type Edge = {
  cursor: Scalars['String'];
};

export enum Effect {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type FederatedIdentity = {
  __typename?: 'FederatedIdentity';
  /** The federated identity's id */
  id: Scalars['Int'];
  /** List of Application Users the federated identity is linked to */
  linkedWith: Array<ApplicationUser>;
};

export type GetBillingAccountInput = {
  billingAccountId: Scalars['ID'];
};

/** Represents a credit memo (AR adjustment) from Intacct */
export type IntacctCreditMemo = {
  __typename?: 'IntacctCreditMemo';
  /** Currency code for the credit memo */
  currency: Maybe<Scalars['String']>;
  /** Description of the credit memo */
  description: Maybe<Scalars['String']>;
  /** Document number for the credit memo */
  docNo: Maybe<Scalars['String']>;
  /** Unique record number from Intacct */
  recordNo: Scalars['Int'];
  /** Current state of the credit memo (e.g., Posted) */
  state: Scalars['String'];
  /** Total amount due on the credit memo */
  totalDue: Scalars['String'];
  /** Total amount entered on the credit memo */
  totalEntered: Maybe<Scalars['String']>;
  /** Date when the credit memo was created */
  whenCreated: Scalars['DateTime'];
};

/** Represents an invoice from Intacct */
export type IntacctInvoice = {
  __typename?: 'IntacctInvoice';
  /** Currency code for the invoice */
  currency: Scalars['String'];
  /** Document number for the invoice */
  docNo: Scalars['String'];
  /**
   * Payment processing status from Snowflake STAGED_PAYMENTS.
   * Null if no in-flight payment exists. "PROCESSING" if payment
   * was submitted but Intacct hasn't been updated yet.
   */
  paymentProcessingStatus: Maybe<Scalars['String']>;
  /** Unique record number from Intacct */
  recordNo: Scalars['Int'];
  /** Current state of the invoice (e.g., Open, Paid) */
  state: Scalars['String'];
  /**
   * Outstanding balance for the invoice as tracked by Intacct (TOTALDUE).
   * Reflects payments and applied credit memos, so it is the authoritative
   * remaining balance rather than a client-side computed value.
   */
  totalDue: Scalars['String'];
  /** Total amount entered for the invoice */
  totalEntered: Scalars['String'];
  /** Date when the invoice was created */
  whenCreated: Scalars['DateTime'];
  /** Due date for the invoice */
  whenDue: Scalars['DateTime'];
};

/** Represents a payment from Intacct */
export type IntacctPayment = {
  __typename?: 'IntacctPayment';
  /** List of allocations showing how the payment was applied to invoices */
  allocations: Array<IntacctPaymentAllocation>;
  /** Currency code for the payment */
  currency: Scalars['String'];
  /** Customer ID associated with the payment */
  customerId: Scalars['String'];
  /** Unique record number from Intacct */
  recordNo: Scalars['Int'];
  /** Total amount entered for the payment */
  totalEntered: Scalars['String'];
  /** Unused amount from the payment */
  unusedAmount: Scalars['String'];
  /** Date when the payment was created */
  whenCreated: Scalars['DateTime'];
};

/** Represents a payment allocation to an invoice from Intacct */
export type IntacctPaymentAllocation = {
  __typename?: 'IntacctPaymentAllocation';
  /** Amount applied to the invoice */
  amountApplied: Scalars['String'];
  /** Record number of the invoice this allocation applies to */
  invoiceRecordNo: Scalars['String'];
};

export type InvoiceBillingAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type InvoicePaymentInput = {
  billingAccountId: Scalars['String'];
  invoiceRecordNos: Array<Scalars['Int']>;
  payment: InvoicePaymentMethodInput;
  totalAmountInCents: Scalars['Int'];
};

export type InvoicePaymentMethodInput = {
  billingAddress: InputMaybe<InvoiceBillingAddressInput>;
  saveCreditCard: InputMaybe<Scalars['Boolean']>;
  stripeCardId: InputMaybe<Scalars['String']>;
  stripeTokenId: InputMaybe<Scalars['String']>;
};

export type InvoicePaymentResult = {
  __typename?: 'InvoicePaymentResult';
  chargeId: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  successful: Scalars['Boolean'];
};

/** The response object that is returned by the getLinkToken Query */
export type LinkTokenResponse = {
  __typename?: 'LinkTokenResponse';
  token: Scalars['String'];
};

export enum MfaMethods {
  Email = 'email'
}

/** MSTS Specific values. */
export type Msts = PaymentMethodInterface & {
  __typename?: 'MSTS';
  /** Name of Business */
  businessName: Scalars['String'];
  /** Credit held by a client. Could use help expanding this */
  creditHeld: Scalars['Int'];
  /** The largest amount of credit available to a user */
  creditLimit: Scalars['Int'];
  /** Credit so far used by a user */
  creditUsed: Scalars['Int'];
  /** Primary ID for MSTS */
  id: Scalars['ID'];
  /** ???? */
  status: Scalars['String'];
  /** 'msts' */
  type: Scalars['String'];
};

/** Mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * A mutation to accept or decline an invite to an organization
   * Requires an authenticated user
   */
  acceptOrganizationInvite: OrganizationMutationSuccess;
  /** Adds a bank account to a users stripe account. Will create a stripe account if user doesn't have one. */
  addBankAccount: PaymentMethod;
  /**
   * A mutation to add one or more grantable organization user permissions to the org api permissions table
   * On success returns an array of all grantable permission objects
   * Requires Staff Authorization
   */
  addOrganizationPermissions: Array<Maybe<OrganizationPermission>>;
  /**
   * A mutation to add a user to an organization
   * Not yet implemented
   */
  addOrganizationsUsers: OrganizationMutationSuccess;
  /** Adds a stripe card to a users stripe account. Will create a stripe account if user doesn't have one. */
  addStripeCard: PaymentMethod;
  addTaxExemptionUrl: Maybe<Scalars['String']>;
  /** Creates an authorization with a certain payment method. */
  authPayment: AuthPaymentReturn;
  /** Captures a payment. Authorization is now optional resulting in an immediate capture. */
  capturePayment: CapturePaymentReturn;
  /** Creates an authorization with a certain payment method. */
  checkout: CheckoutPaymentReturn;
  /**
   * Convert all invitation emails to lowercase
   * Requires Staff Authorization
   */
  convertAllOrganizationInvitationEmailsToLowercase: OrganizationMutationSuccess;
  createBillingAccount: Maybe<CreateBillingAccountResult>;
  createCreditApplication: Maybe<CreateCreditApplicationResponse>;
  /** A mutation to create an organization. A non staff user will automatically be added as a member to the new organization. */
  createOrganization: Organization;
  /** Organization Quote Presets */
  createOrganizationQuotePreset: Organization;
  /** A mutation to create a shipping account. Only Admin can perfome this action */
  createOrganizationShippingAccount: OrganizationShippingAccount;
  /** A mutation to create a shipping address. Only Admin can perfome this action */
  createOrganizationShippingAddress: OrganizationShippingAddress;
  /**
   * A mutation to soft delete an invitation
   * Requires an authenticated user with "write:users" permission
   */
  deleteInvitationForOrganization: OrganizationMutationSuccess;
  /**
   * A mutation to soft delete an organization
   * The mutation will remove all associated organization users and their associated permissions
   * Requires Staff Authorization OR an organizationUser with "write:organizations" permission
   * Once deleted, an organization may not add users, update metadata, or be re-deleted
   */
  deleteOrganizationById: OrganizationMutationSuccess;
  /**
   * A mutation to delete one grantable organization permission by id in the org api permissions table
   * On deletion this will cascade to delete all references to the permission in the users_permissions table
   * On success returns the OrganizationMutationSuccess boolean
   * Requires Staff Authorization
   */
  deleteOrganizationPermissionById: OrganizationMutationSuccess;
  deleteOrganizationQuotePreset: Organization;
  /** A mutation to soft delete a shipping Account. Only Admin can perfome this action */
  deleteOrganizationShippingAccountById: ShippingAccountMutationSuccess;
  /** A mutation to soft delete a shipping address. Only Admin can perfome this action */
  deleteOrganizationShippingAddressById: OrganizationShippingAddressMutationSuccess;
  deleteTaxExemption: Maybe<Scalars['Boolean']>;
  payInvoices: InvoicePaymentResult;
  /**
   * Refund a captured payment.
   * NOTE: Amount is an available parameter, but does not do anything until partial payments are implemented. Until then,
   *       captured payments are refunded in full. - cstephenson
   */
  refundPayment: RefundPaymentReturn;
  /** Removes a bank account from a users stripe account. */
  removeBankAccount: RemoveBankAccountMutationResponse;
  /** Removes a user chosen checkout method for a "XomPay Checkout" */
  removeBuyerCheckoutSelection: Maybe<BuyerCheckoutSelectionMutationResponse>;
  /**
   * A mutation to remove one or more users from an organization
   * Requires Staff Authorization OR an organizationUser with "write:users" permission
   */
  removeOrganizationUsers: OrganizationMutationSuccess;
  /** Removes a stripe card from a users stripe account. */
  removeStripeCard: RemoveStripeCardMutationResponse;
  /**
   * A mutation to invite users to an organization. Sends invitations to recipients via email.
   * Requires Staff Authorization OR an organizationUser with "write:users" permission
   */
  sendOrganizationInvitations: Array<OrganizationInvitationResponse>;
  setAccountPermission: Maybe<SetAccountPermissionResponse>;
  setBillingAccountAddress: Maybe<SetBillingAccountAddressResult>;
  /** Set the current world status. This method is only available to logged-in users. */
  setStatus: Maybe<SetStatusPayload>;
  setUserPermission: Maybe<SetUserPermissionResponse>;
  /**
   * A mutation to update an organization
   * Requires Staff Authorization OR an organizationUser with "write:organizations" permission
   */
  updateOrganizationById: Organization;
  /**
   * Change the roles of open invitations by email address.
   * Requires staff authorization or an organizationUser with "write:organizations" permission
   */
  updateOrganizationInvitationRoles: Array<OrganizationInvitation>;
  /** Update Organization is Archived field */
  updateOrganizationIsArchived: Organization;
  /**
   * Change the role of a member of an organization.
   * Requires staff authorization or an organizationUser with "write:organizations" permission
   */
  updateOrganizationMemberRoleByMemberId: OrganizationUser;
  /**
   * A mutation to update one grantable organization permission by id in the org api permissions table
   * On success returns the updated grantable permission object
   * Requires Staff Authorization
   */
  updateOrganizationPermissionById: OrganizationPermission;
  updateOrganizationQuotePreset: Organization;
  /** A mutation to update a shipping account. Only Admin can perfome this action */
  updateOrganizationShippingAccountById: OrganizationShippingAccount;
  /** A mutation to update a shipping address. Only Admin can perfome this action */
  updateOrganizationShippingAddressById: OrganizationShippingAddress;
  uploadPaymentFile: PaymentFile;
  uploadPaymentFiles: Array<PaymentFile>;
  /**
   * Adds or modifies a user chosen checkout method for a "XomPay Checkout".
   * Each stored selection is unique based on the combination of:
   *   - checkoutIdentifier (<entity_prefix>-<uuid>)
   *   - paaymentMethodId
   *   - paymentMethodType
   */
  upsertBuyerCheckoutSelection: Maybe<BuyerCheckoutSelectionMutationResponse>;
  /**
   * Mark a user as having accepted General TOS and Privacy Policy
   *
   * Access: staff and user if id in JWT matches requested user id
   *
   * Return: User ID if successful
   */
  userAcceptTos: Maybe<Scalars['ID']>;
};


/** Mutations */
export type MutationAcceptOrganizationInviteArgs = {
  acceptInvite: Scalars['Boolean'];
  orgId: Scalars['ID'];
};


/** Mutations */
export type MutationAddBankAccountArgs = {
  accountIds: Array<Scalars['String']>;
  token: Scalars['String'];
};


/** Mutations */
export type MutationAddOrganizationPermissionsArgs = {
  permissions: Array<OrganizationPermissionInput>;
};


/** Mutations */
export type MutationAddOrganizationsUsersArgs = {
  user: OrganizationUserInput;
};


/** Mutations */
export type MutationAddStripeCardArgs = {
  token: Scalars['String'];
};


/** Mutations */
export type MutationAddTaxExemptionUrlArgs = {
  input: AddTaxExemptionInput;
};


/** Mutations */
export type MutationAuthPaymentArgs = {
  amount: Scalars['Int'];
  checkoutIdentifier: Scalars['String'];
  description: Scalars['String'];
  paymentMethodId: Scalars['ID'];
  paymentMethodType: Scalars['String'];
};


/** Mutations */
export type MutationCapturePaymentArgs = {
  amount: InputMaybe<Scalars['Int']>;
  authorizationId: InputMaybe<Scalars['Int']>;
  checkoutIdentifier: Scalars['String'];
  description: Scalars['String'];
  lineItems: Array<PaymentCaptureLineItemInput>;
  paymentMethodId: Scalars['ID'];
  paymentMethodType: Scalars['String'];
};


/** Mutations */
export type MutationCheckoutArgs = {
  amount: InputMaybe<Scalars['Int']>;
  callbackMutation: InputMaybe<Scalars['String']>;
  checkoutIdentifier: Scalars['String'];
  description: Scalars['String'];
  lineItems: Array<PaymentCaptureLineItemInput>;
  paymentMethodId: Scalars['ID'];
  paymentMethodType: Scalars['String'];
};


/** Mutations */
export type MutationCreateBillingAccountArgs = {
  input: CreateBillingAccountInput;
};


/** Mutations */
export type MutationCreateCreditApplicationArgs = {
  input: CreateCreditApplicationInput;
};


/** Mutations */
export type MutationCreateOrganizationArgs = {
  organization: OrganizationInput;
};


/** Mutations */
export type MutationCreateOrganizationQuotePresetArgs = {
  MenuId: Scalars['String'];
  OrgId: Scalars['ID'];
  QuotePresets: QuotePresetsInput;
};


/** Mutations */
export type MutationCreateOrganizationShippingAccountArgs = {
  shippingAccount: OrganizationShippingAccountInput;
};


/** Mutations */
export type MutationCreateOrganizationShippingAddressArgs = {
  shippingAddress: OrganizationShippingAddressInput;
};


/** Mutations */
export type MutationDeleteInvitationForOrganizationArgs = {
  memberEmail: Scalars['String'];
  orgId: Scalars['ID'];
};


/** Mutations */
export type MutationDeleteOrganizationByIdArgs = {
  id: Scalars['ID'];
};


/** Mutations */
export type MutationDeleteOrganizationPermissionByIdArgs = {
  permissionId: Scalars['ID'];
};


/** Mutations */
export type MutationDeleteOrganizationQuotePresetArgs = {
  OrgId: Scalars['ID'];
  OrgQuotePresetId: Scalars['Int'];
};


/** Mutations */
export type MutationDeleteOrganizationShippingAccountByIdArgs = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
};


/** Mutations */
export type MutationDeleteOrganizationShippingAddressByIdArgs = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
};


/** Mutations */
export type MutationDeleteTaxExemptionArgs = {
  input: DeleteTaxExemptionInput;
};


/** Mutations */
export type MutationPayInvoicesArgs = {
  input: InvoicePaymentInput;
};


/** Mutations */
export type MutationRefundPaymentArgs = {
  amount: InputMaybe<Scalars['Int']>;
  captureId: Scalars['Int'];
  checkoutIdentifier: Scalars['String'];
  paymentMethodType: Scalars['String'];
};


/** Mutations */
export type MutationRemoveBankAccountArgs = {
  accountId: Scalars['String'];
};


/** Mutations */
export type MutationRemoveBuyerCheckoutSelectionArgs = {
  checkoutIdentifier: Scalars['String'];
  paymentMethodId: Scalars['ID'];
  paymentMethodType: Scalars['String'];
};


/** Mutations */
export type MutationRemoveOrganizationUsersArgs = {
  memberIds: Array<Scalars['ID']>;
  orgId: Scalars['ID'];
};


/** Mutations */
export type MutationRemoveStripeCardArgs = {
  cardId: Scalars['String'];
};


/** Mutations */
export type MutationSendOrganizationInvitationsArgs = {
  addUsersInput: OrganizationUsersByEmailsInput;
};


/** Mutations */
export type MutationSetAccountPermissionArgs = {
  input: SetAccountPermissionInput;
};


/** Mutations */
export type MutationSetBillingAccountAddressArgs = {
  input: SetBillingAccountAddressInput;
};


/** Mutations */
export type MutationSetStatusArgs = {
  input: SetStatusInput;
};


/** Mutations */
export type MutationSetUserPermissionArgs = {
  input: SetUserPermissionInput;
};


/** Mutations */
export type MutationUpdateOrganizationByIdArgs = {
  id: Scalars['ID'];
  organization: OrganizationUpdateInput;
};


/** Mutations */
export type MutationUpdateOrganizationInvitationRolesArgs = {
  emails: Array<Scalars['String']>;
  orgId: Scalars['ID'];
  roleId: Scalars['ID'];
};


/** Mutations */
export type MutationUpdateOrganizationIsArchivedArgs = {
  isArchived: Scalars['Boolean'];
  orgId: Scalars['ID'];
};


/** Mutations */
export type MutationUpdateOrganizationMemberRoleByMemberIdArgs = {
  memberId: Scalars['ID'];
  orgId: Scalars['ID'];
  roleId: Scalars['ID'];
};


/** Mutations */
export type MutationUpdateOrganizationPermissionByIdArgs = {
  permission: OrganizationPermissionInput;
  permissionId: Scalars['ID'];
};


/** Mutations */
export type MutationUpdateOrganizationQuotePresetArgs = {
  MenuId: Scalars['String'];
  OrgId: Scalars['ID'];
  QuotePresets: QuotePresetsUpdateInput;
};


/** Mutations */
export type MutationUpdateOrganizationShippingAccountByIdArgs = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  shippingAccount: OrganizationShippingAccountUpdateInput;
};


/** Mutations */
export type MutationUpdateOrganizationShippingAddressByIdArgs = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  shippingAddress: OrganizationShippingAddressUpdateInput;
};


/** Mutations */
export type MutationUploadPaymentFileArgs = {
  acls: Array<PaymentFileAcl>;
  bucket: InputMaybe<PaymentFileS3Bucket>;
  file: Scalars['Upload'];
  userFileAttributes: InputMaybe<Scalars['String']>;
};


/** Mutations */
export type MutationUploadPaymentFilesArgs = {
  acls: Array<PaymentFileAcl>;
  bucket: InputMaybe<PaymentFileS3Bucket>;
  files: Array<Scalars['Upload']>;
  userFileAttributes: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Mutations */
export type MutationUpsertBuyerCheckoutSelectionArgs = {
  amount: Scalars['Int'];
  checkoutIdentifier: Scalars['String'];
  paymentMethodId: Scalars['ID'];
  paymentMethodType: Scalars['String'];
};


/** Mutations */
export type MutationUserAcceptTosArgs = {
  id: Scalars['ID'];
  vendor: InputMaybe<Scalars['Boolean']>;
};

export type MutationResponse = {
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Node = {
  id: Scalars['ID'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** A return type to indicate the success of organization operation(create, update, etc) */
export type Organization = {
  __typename?: 'Organization';
  /** Count active members for that org */
  activeMembers: Maybe<Scalars['Int']>;
  /** List of available roles that members of this organization can own */
  availableRoles: Array<OrganizationRole>;
  /** DUNS of the company or organization. It's a nine-digit string unique identifier for businesses */
  duns: Maybe<Scalars['String']>;
  /** Employer Identification Number (EIN) of the company or organization. It's a nine-digit string */
  ein: Maybe<Scalars['String']>;
  /** Unique index id of the organization */
  id: Scalars['ID'];
  /** Is the organization is archived or not */
  isArchived: Maybe<Scalars['Boolean']>;
  /** Human readable legal name of the company or organization */
  legalName: Maybe<Scalars['String']>;
  /** Human readable name of the organization */
  name: Scalars['String'];
  /** l-tree, will be composed of organizations ids. Will be used to define hierarchy structure in an organization. Example: 41135.41137 */
  path: Maybe<Scalars['String']>;
  /** The quote presets for the organization user */
  quotePresets: Array<OrganizationQuotePreset>;
  /** Unique randomly generated ID of the organization */
  refId: Scalars['String'];
};

export type OrganizationAndUserPermission = {
  __typename?: 'OrganizationAndUserPermission';
  name: Scalars['String'];
  orgId: Scalars['Int'];
  permissions: Array<Maybe<Scalars['String']>>;
};

/** Organization Defaults */
export type OrganizationDefault = {
  __typename?: 'OrganizationDefault';
  /** The organization that these defaults apply to */
  organization: Maybe<Organization>;
  /** The quote presets for the organization user */
  quotePresets: Array<OrganizationQuotePreset>;
  /** This organizations's default shipping account */
  shippingAccount: Maybe<OrganizationShippingAccount>;
  /** This organizations default shipping address */
  shippingAddress: Maybe<OrganizationShippingAddress>;
};

export type OrganizationEvent = {
  __typename?: 'OrganizationEvent';
  actor: OrganizationUserData;
  actorIsStaff: Scalars['Boolean'];
  affectedMembers: Array<OrganizationUserData>;
  date: Scalars['Date'];
  eventData: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  type: Scalars['String'];
};

/** Return the federatedIdentity and the xometry user data */
export type OrganizationFederatedUser = {
  __typename?: 'OrganizationFederatedUser';
  /** An object with the federated identity id of the user and the list of application they linked to */
  federatedIdentity: Maybe<FederatedIdentity>;
  /** Return the xometry user data */
  userData: Maybe<OrganizationUserData>;
};

/** The input object to create an organization */
export type OrganizationInput = {
  /** DUNS of the company or organization. It's a nine-digit string unique identifier for businesses */
  duns: InputMaybe<Scalars['String']>;
  /** Employer Identification Number (EIN) of the company or organization. It's a nine-digit string */
  ein: InputMaybe<Scalars['String']>;
  /** Human readable legal name of the company or organization */
  legalName: InputMaybe<Scalars['String']>;
  /** Required human readable name of the organization */
  name: Scalars['String'];
  /** l-tree, will be composed of organizations ids. Will be used to define hierarchy structure in an organization. Example: 41135.41137 */
  path: InputMaybe<Scalars['String']>;
};

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  /** The link to accept the organization invitation */
  acceptInviteUrl: Maybe<Scalars['String']>;
  /** Date the invitation was sent */
  date: Scalars['Date'];
  /** The link to decline the organization invitation */
  declineInviteUrl: Maybe<Scalars['String']>;
  /** Unique index id of the organization user */
  id: Scalars['ID'];
  /** The organization that owns this invitation */
  organization: Organization;
  /** The role that the member will assume once accepting the invitation */
  role: Maybe<OrganizationRole>;
  /** The xometry user data of the sender */
  senderUserData: Maybe<OrganizationUserData>;
  /** Status of the invitation */
  status: Scalars['String'];
  /** Return the xometry user data of the recipient */
  userData: Maybe<OrganizationUserData>;
};

/** A return type for sending an organization invitation to a new member */
export type OrganizationInvitationResponse = {
  __typename?: 'OrganizationInvitationResponse';
  /** The link to accept the organization invitation */
  acceptInviteUrl: Maybe<Scalars['String']>;
  /** The link to decline the organization invitation */
  declineInviteUrl: Maybe<Scalars['String']>;
  /** The email passed in to the mutation */
  email: Scalars['String'];
  /** The HTTP status code received after sending the invitation email */
  emailStatusCode: Maybe<Scalars['Int']>;
  /** The status message received from sending the invitation email */
  emailStatusMessage: Maybe<Scalars['String']>;
  /** Status of the invitation */
  status: Scalars['String'];
};

/** A return type to indicate the success of any organization operation (deleteOrganizationByIdMutation, addOrganizationsUsers, etc) */
export type OrganizationMutationSuccess = {
  __typename?: 'OrganizationMutationSuccess';
  success: Scalars['Boolean'];
};

/** An entity that represents permissions that a user may own in an organization. */
export type OrganizationPermission = {
  __typename?: 'OrganizationPermission';
  /** Human readable description of the permission */
  description: Maybe<Scalars['String']>;
  /** Unique index id of the permission */
  id: Scalars['ID'];
  /** Machine readable name of the permission */
  name: Scalars['String'];
};

/** The required input object to create an organization permission */
export type OrganizationPermissionInput = {
  /** The human readable description of the permission (optional) */
  description: InputMaybe<Scalars['String']>;
  /**
   * Machine readable name of the permission ex. read:organizations
   * Required syntax is `action:resource` or `action:resource:descriptor`
   */
  name: Scalars['String'];
};

export type OrganizationQuotePreset = {
  __typename?: 'OrganizationQuotePreset';
  createdAt: Maybe<Scalars['Date']>;
  createdBy: Maybe<OrganizationUserData>;
  id: Scalars['ID'];
  invalidRequirement: Maybe<Scalars['String']>;
  menuId: Scalars['String'];
  organizationId: Scalars['ID'];
  patchRequirement: Maybe<Scalars['JSON']>;
  updatedAt: Maybe<Scalars['Date']>;
  updatedBy: Maybe<OrganizationUserData>;
};

/** An entity that represents roles that a user may own in an organization. */
export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  /** Unique index id of the permission */
  id: Scalars['ID'];
  /** Machine readable name of the permission */
  name: Scalars['String'];
  /** An array of permissions associated with this role */
  permissions: Array<OrganizationPermission>;
};

export type OrganizationShippingAccount = {
  __typename?: 'OrganizationShippingAccount';
  /** account number associated with the shipping account */
  accountNumber: Scalars['String'];
  /** Unique index id of the shipping account */
  id: Scalars['ID'];
  /** flag to indicate if the account is deleted */
  isDeleted: Scalars['Boolean'];
  /** flag to indicate if this is the default account for the team/organization */
  isTeamDefault: Scalars['Boolean'];
  /** organizationId of the shipping account */
  organizationId: Scalars['ID'];
  /** provider of the shipping account (e.g. FedEx, UPS) */
  provider: Scalars['String'];
};

/** The required input object to create a shipping account for an organization */
export type OrganizationShippingAccountInput = {
  /** Required account number associated with the shipping account */
  accountNumber: Scalars['String'];
  /** Required flag to indicate if this is the default account for the team/organization */
  isTeamDefault: Scalars['Boolean'];
  /** Required organizationId of the shipping account */
  organizationId: Scalars['ID'];
  /** Required provider of the shipping account (e.g. FedEx, UPS) */
  provider: Scalars['String'];
};

/** The required input object to update a shipping account for an organization */
export type OrganizationShippingAccountUpdateInput = {
  /** Required account number associated with the shipping account */
  accountNumber: InputMaybe<Scalars['String']>;
  /** Required flag to indicate if this is the default account for the team/organization */
  isTeamDefault: InputMaybe<Scalars['Boolean']>;
  /** Required organizationId of the shipping account */
  organizationId: InputMaybe<Scalars['ID']>;
  /** Required provider of the shipping account (e.g. FedEx, UPS) */
  provider: InputMaybe<Scalars['String']>;
};

export type OrganizationShippingAddress = {
  __typename?: 'OrganizationShippingAddress';
  /** city of the address */
  city: Scalars['String'];
  /** countryCode of the address */
  countryCode: Scalars['String'];
  /** email address of the person related to the address */
  emailAddress: Scalars['String'];
  /** Unique index id of the shipping address */
  id: Scalars['ID'];
  /** flag to indicate if the address is deleted */
  isDeleted: Scalars['Boolean'];
  /** flag to indicate if the address is the default address for the organization */
  isTeamDefault: Scalars['Boolean'];
  /** name of the person related to the address, this name is choosed by the user */
  name: Scalars['String'];
  /** organizationId of the address */
  organizationId: Scalars['ID'];
  /** phone number of the person related to the address */
  phoneNumber: Scalars['String'];
  /** state of the address */
  state: Scalars['String'];
  /** street1 of the address */
  street1: Scalars['String'];
  /** street2 of the address */
  street2: Maybe<Scalars['String']>;
  /** flag to indicate if the address is valid */
  validated: Scalars['Boolean'];
  /** flag to indicate if the address is exempt from validation */
  validationExempt: Scalars['Boolean'];
  /** zipcode of the address */
  zipcode: Scalars['String'];
};

/** The required input object to create an shipping address for an organization */
export type OrganizationShippingAddressInput = {
  /** Required city of the address */
  city: Scalars['String'];
  /** Required countryCode of the address */
  countryCode: Scalars['String'];
  /** Required emailAddress of the person related to the address */
  emailAddress: Scalars['String'];
  /** Required isTeamDefault of the address */
  isTeamDefault: Scalars['Boolean'];
  /** Required name of the person related to the address */
  name: Scalars['String'];
  /** Required organizationId of the address */
  organizationId: Scalars['ID'];
  /** Required phoneNumber of the person related to the address */
  phoneNumber: Scalars['String'];
  /** Required state of the address */
  state: Scalars['String'];
  /** Required street1 of the address */
  street1: Scalars['String'];
  /** Optional street2 of the address */
  street2: InputMaybe<Scalars['String']>;
  /** Required field to indicate if the address is valid */
  validated: Scalars['Boolean'];
  /** Required field to indicate if the address is exempt from validation */
  validationExempt: Scalars['Boolean'];
  /** Required zipcode of the address */
  zipcode: Scalars['String'];
};

/** A return type to indicate the success of any shipping address operation */
export type OrganizationShippingAddressMutationSuccess = {
  __typename?: 'OrganizationShippingAddressMutationSuccess';
  success: Scalars['Boolean'];
};

/** The optional input object to update an shipping address for an organization */
export type OrganizationShippingAddressUpdateInput = {
  /** city of the address */
  city: InputMaybe<Scalars['String']>;
  /** countryCode of the address */
  countryCode: InputMaybe<Scalars['String']>;
  /** emailAddress of the person related to the address */
  emailAddress: InputMaybe<Scalars['String']>;
  /** isTeamDefault of the address */
  isTeamDefault: InputMaybe<Scalars['Boolean']>;
  /** name of the person related to the address */
  name: InputMaybe<Scalars['String']>;
  /** organizationId of the address */
  organizationId: InputMaybe<Scalars['ID']>;
  /** phoneNumber of the person related to the address */
  phoneNumber: InputMaybe<Scalars['String']>;
  /** state of the address */
  state: InputMaybe<Scalars['String']>;
  /** street1 of the address */
  street1: InputMaybe<Scalars['String']>;
  /** street2 of the address */
  street2: InputMaybe<Scalars['String']>;
  /** Required field to indicate if the address is valid */
  validated: InputMaybe<Scalars['Boolean']>;
  /** Required field to indicate if the address is exempt from validation */
  validationExempt: InputMaybe<Scalars['Boolean']>;
  /** zipcode of the address */
  zipcode: InputMaybe<Scalars['String']>;
};

/** The input object to update an organization */
export type OrganizationUpdateInput = {
  /** DUNS of the company or organization. It's a nine-digit string unique identifier for businesses */
  duns: InputMaybe<Scalars['String']>;
  /** Employer Identification Number (EIN) of the company or organization. It's a nine-digit string */
  ein: InputMaybe<Scalars['String']>;
  /** Human readable legal name of the company or organization */
  legalName: InputMaybe<Scalars['String']>;
  /** Human readable name of the organization */
  name: InputMaybe<Scalars['String']>;
  /** l-tree, will be composed of organizations ids. Will be used to define hierarchy structure in an organization. Example: 41135.41137 */
  path: InputMaybe<Scalars['String']>;
};

/** A return type to indicate the success of the getOrganizationUsersQuery */
export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  /** date the invitation was sent */
  date: Scalars['Date'];
  /** The federation identity ID of the member */
  federatedIdentityId: Maybe<Scalars['ID']>;
  /** The federated identity of the user */
  federatedUser: Maybe<OrganizationFederatedUser>;
  /** Unique index id of the organization user */
  id: Scalars['ID'];
  /** Indicates if the member is auto sharing their quotes with this team */
  isAutoSharingQuotes: Maybe<Scalars['Boolean']>;
  /** The id of the organization to which the organization user belong to */
  organizationId: Scalars['ID'];
  /** An array of permission objects of the organization user */
  permissions: Array<Maybe<OrganizationPermission>>;
  /** The quote presets for the organization user */
  quotePresets: Maybe<OrganizationQuotePreset>;
  /** The role that this user owns in the organizaiton */
  role: OrganizationRole;
  /** The Xometry user ID of the member */
  userId: Maybe<Scalars['ID']>;
};

/** Return xometry user data */
export type OrganizationUserData = {
  __typename?: 'OrganizationUserData';
  /** email of the  user */
  email: Maybe<Scalars['String']>;
  /** first name of the  user */
  firstName: Maybe<Scalars['String']>;
  /** last name of the  user */
  lastName: Maybe<Scalars['String']>;
  /** user id */
  userId: Maybe<Scalars['ID']>;
};

/** The required input object to add a user to an organization with provided permissions */
export type OrganizationUserInput = {
  /** The federated identity id of the user */
  federatedIdentityId: Scalars['ID'];
  /** The id of the organization to which the users will be added */
  organizationId: Scalars['ID'];
  /** An array of ids for permissions which will be associated with each created organization user */
  permissionIds: Array<Scalars['ID']>;
};

/** The required input object to upsert the organization permissions for a user */
export type OrganizationUserPermissionInput = {
  /** The federated identity id of the user */
  federatedIdentityId: Scalars['ID'];
  /** The organization id of the organization */
  organizationId: Scalars['ID'];
  /** An array of permission ids to assign to the organization user */
  permissionIds: Array<Scalars['ID']>;
};

/** The required input object to add users to an organization with provided permissions */
export type OrganizationUsersByEmailsInput = {
  /** An array of emails which are each associated with a federated identity for a user */
  emails: Array<Scalars['String']>;
  /** The id of the organization to which the users will be added */
  organizationId: Scalars['ID'];
  /** An array of ids for permissions which will be associated with each created organization user */
  permissionIds: Array<Scalars['ID']>;
  /** The id of the role to which the users will be part of */
  roleId: InputMaybe<Scalars['ID']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']>;
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  startCursor: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type PageInput = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']>;
};

export type Partner = {
  __typename?: 'Partner';
  /** Id of the partner. */
  id: Scalars['String'];
};

export type PartnerByUserId = {
  __typename?: 'PartnerByUserId';
  /** Array of partners that could be empty but all partners associated with the user-id */
  partner: Maybe<Partner>;
};

/** Line Item Structure */
export type PaymentCaptureLineItemInput = {
  /** Denomination that the amount is in. Ex USD */
  currencyCode: Scalars['String'];
  /** Item Code, short descriptor */
  itemCode: Scalars['String'];
  /** How many of the line item is being bought */
  quantity: Scalars['Int'];
  /** Title of the item being bought */
  title: Scalars['String'];
  /** How much the item costs */
  unitPrice: Scalars['Int'];
};

export type PaymentFile = {
  __typename?: 'PaymentFile';
  encoding: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  mimetype: Scalars['String'];
  s3Bucket: PaymentFileS3Bucket;
  serviceOrigin: Scalars['String'];
  uploadDate: Scalars['String'];
  uploadedByUserID: Scalars['String'];
  url: Scalars['String'];
  userFileAttributes: Maybe<Scalars['String']>;
};

/** PaymentFileACL - https://en.wikipedia.org/wiki/Access-control_list */
export type PaymentFileAcl = {
  /**
   * access - access level
   * e.g., "read" | "write"
   */
  access: Scalars['String'];
  /**
   * entity - the type of entity being given access
   * e.g., "user" | "company" | "email" | "payment request"
   */
  entity: Scalars['String'];
  /**
   * id - entity's ID
   * e.g., "00971" | "57dbdea19821cc0e0d21c32f" | "criley@xometry.com" | "e6ba6590-7873-439f-a0b3-c9c419740b68"
   */
  id: Scalars['ID'];
};

/** Enum of the two S3 buckets */
export enum PaymentFileS3Bucket {
  FinanceDocuments = 'finance_documents',
  PaymentFiles = 'payment_files'
}

export type PaymentFileUpsertInput = {
  /**
   * The file to be uploaded.
   * Access: Staff, payment admin members
   */
  fileUpload: Scalars['Upload'];
  /**
   * The ID generated by the database. If ID is given, that record will be updated instead of created
   * Access: Staff
   */
  id: InputMaybe<Scalars['ID']>;
};

export type PaymentMethod = AvailableBalance | BankAccount | Msts | StripeCard;

/** Wrapper Type for our payment methods */
export type PaymentMethodInterface = {
  id: Scalars['ID'];
  /**
   * Abstract variable that contains the specific name of a given implemented method type.
   * Currently Supported values: 'msts', 'stripecard'
   */
  type: Scalars['String'];
};

export type Permission = {
  __typename?: 'Permission';
  effect: Effect;
  name: Scalars['String'];
};

export type PermissionInput = {
  effect: Effect;
  name: Scalars['String'];
};

/** Root Query */
export type Query = {
  __typename?: 'Query';
  /** Finds an authorization by its primary key id. */
  authorizationById: Authorization;
  /** Returns all authorizations associated to a checkout */
  authorizationsByCheckoutIdentifier: Maybe<Array<Authorization>>;
  /** Returns all checkout configurations associated to this checkout */
  buyerCheckoutSelectionsByCheckoutIdentifier: Maybe<Array<BuyerCheckoutSelection>>;
  /** Returns all captures associated to a (checkout or paymentMethod or successful or userId) */
  captures: Maybe<Array<Capture>>;
  /**
   * DEPRECATED
   * Returns all captures associated to a checkout
   */
  capturesByCheckoutIdentifier: Maybe<Array<Capture>>;
  /** The current world status, as determined by users. This may be null in normal operation. */
  currentStatus: Maybe<Scalars['String']>;
  getBillingAccount: Maybe<BillingAccount>;
  getBillingAccountUser: Maybe<User>;
  getBillingAccounts: Maybe<BillingAccountsConnection>;
  /** Lists the Payment Methods of the logged in user */
  getLinkToken: LinkTokenResponse;
  /** Fetch all invitation for a user. Frontend can filter by sent or pending status */
  getMyOrganizationInvitations: Array<OrganizationInvitation>;
  /**
   * Fetch an organization by id. The provided input will match organizations by either their id or their refId.
   * Requires Staff Authorization OR an organizationUser with "read:organizations" permission
   */
  getOrganizationById: Organization;
  /** Get all defaults of requested organization ids and return Organization Default */
  getOrganizationDefaultsByOrganizationIds: Array<Maybe<OrganizationDefault>>;
  getOrganizationEvents: Array<OrganizationEvent>;
  /**
   * Fetch all pending users that belong to an organization
   * Requires Staff Authorization
   */
  getOrganizationInvitations: Array<Maybe<OrganizationInvitation>>;
  /**
   * Fetch all invitations for a user based on their email address. Only staff and the user who owns the email
   * address may call this query.
   */
  getOrganizationInvitationsByEmail: Array<OrganizationInvitation>;
  /**
   * Fetch all available permissions.
   * Requires no additional authorization
   */
  getOrganizationPermissions: Array<Maybe<OrganizationPermission>>;
  /** Fetch a Shipping account by id. */
  getOrganizationShippingAccountById: OrganizationShippingAccount;
  /** Fetch all Shipping Account by organization id. */
  getOrganizationShippingAccountsByOrganizationId: Array<Maybe<OrganizationShippingAccount>>;
  /** Fetch an Shipping address by id. */
  getOrganizationShippingAddressById: OrganizationShippingAddress;
  /** get all shipping addresses for an organization */
  getOrganizationShippingAddresses: Array<Maybe<OrganizationShippingAddress>>;
  /** Fetch an Shipping address by organization id. */
  getOrganizationShippingAddressesByOrganizationId: Array<Maybe<OrganizationShippingAddress>>;
  /**
   * Fetch all permissions for the current user
   * Requires no additional authorization - the user's own data
   */
  getOrganizationUserPermissionsForMe: Array<Maybe<OrganizationPermission>>;
  /**
   * Fetch all of the users that belong to an organization, their federated identity id and the applications they linked to, xometry userData and their permissions
   * Requires Staff Authorization OR an organizationUser with "read:users" permission
   */
  getOrganizationUsers: Array<Maybe<OrganizationUser>>;
  /** Fetch all organization. */
  getOrganizations: Array<Maybe<Organization>>;
  /** A machine with read:user call this endpoint with a federated identity id to get that user’s organization. */
  getOrganizationsAndPermissionsForUser: Array<Maybe<OrganizationAndUserPermission>>;
  getTaxExemptions: Maybe<Array<Maybe<TaxExemption>>>;
  /**
   * Fetch all organizations for the current user
   * Requires no additional authorization - the user's own data
   */
  getUsersOrganizations: Array<Maybe<Organization>>;
  /** A machine with read:user or staff call this endpoint with application and userId to get that user’s organization. */
  getUsersOrganizationsByIdentity: Array<Organization>;
  hasUserSubmittedApplication: Maybe<UserSubmittedApplication>;
  isEmailInAuth0: Maybe<Scalars['Boolean']>;
  me: Maybe<SessionUser>;
  partnerByUserId: Maybe<PartnerByUserId>;
  paymentFiles: Array<PaymentFile>;
  paymentFilesByUserID: Array<PaymentFile>;
  /** Lists the Payment Methods of the logged in user */
  paymentMethods: Array<Maybe<PaymentMethod>>;
  userById: Maybe<User>;
  userInvitations: Array<UserInvitation>;
};


/** Root Query */
export type QueryAuthorizationByIdArgs = {
  id: Scalars['Int'];
};


/** Root Query */
export type QueryAuthorizationsByCheckoutIdentifierArgs = {
  checkoutIdentifier: Scalars['String'];
};


/** Root Query */
export type QueryBuyerCheckoutSelectionsByCheckoutIdentifierArgs = {
  checkoutIdentifier: Scalars['String'];
};


/** Root Query */
export type QueryCapturesArgs = {
  capturesFilters: CapturesFilters;
};


/** Root Query */
export type QueryCapturesByCheckoutIdentifierArgs = {
  checkoutIdentifier: Scalars['String'];
};


/** Root Query */
export type QueryGetBillingAccountArgs = {
  input: GetBillingAccountInput;
};


/** Root Query */
export type QueryGetBillingAccountUserArgs = {
  userId: Scalars['String'];
};


/** Root Query */
export type QueryGetBillingAccountsArgs = {
  input: InputMaybe<PageInput>;
};


/** Root Query */
export type QueryGetOrganizationByIdArgs = {
  id: Scalars['ID'];
};


/** Root Query */
export type QueryGetOrganizationDefaultsByOrganizationIdsArgs = {
  organizationIds: Array<InputMaybe<Scalars['ID']>>;
};


/** Root Query */
export type QueryGetOrganizationEventsArgs = {
  orgId: Scalars['ID'];
};


/** Root Query */
export type QueryGetOrganizationInvitationsArgs = {
  orgId: Scalars['ID'];
};


/** Root Query */
export type QueryGetOrganizationInvitationsByEmailArgs = {
  email: Scalars['String'];
};


/** Root Query */
export type QueryGetOrganizationShippingAccountByIdArgs = {
  id: Scalars['ID'];
};


/** Root Query */
export type QueryGetOrganizationShippingAccountsByOrganizationIdArgs = {
  organizationId: Scalars['ID'];
};


/** Root Query */
export type QueryGetOrganizationShippingAddressByIdArgs = {
  id: Scalars['ID'];
};


/** Root Query */
export type QueryGetOrganizationShippingAddressesArgs = {
  pageNum: Scalars['Int'];
  pageSize: InputMaybe<Scalars['Int']>;
};


/** Root Query */
export type QueryGetOrganizationShippingAddressesByOrganizationIdArgs = {
  organizationId: Scalars['ID'];
};


/** Root Query */
export type QueryGetOrganizationUserPermissionsForMeArgs = {
  orgId: Scalars['ID'];
};


/** Root Query */
export type QueryGetOrganizationUsersArgs = {
  orgId: Scalars['ID'];
};


/** Root Query */
export type QueryGetOrganizationsArgs = {
  isArchived: InputMaybe<Scalars['Boolean']>;
  pageNum: Scalars['Int'];
  pageSize: InputMaybe<Scalars['Int']>;
};


/** Root Query */
export type QueryGetOrganizationsAndPermissionsForUserArgs = {
  userId: Scalars['String'];
};


/** Root Query */
export type QueryGetTaxExemptionsArgs = {
  userId: Scalars['String'];
};


/** Root Query */
export type QueryGetUsersOrganizationsArgs = {
  isArchived: InputMaybe<Scalars['Boolean']>;
};


/** Root Query */
export type QueryGetUsersOrganizationsByIdentityArgs = {
  application: Scalars['String'];
  isArchived: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};


/** Root Query */
export type QueryHasUserSubmittedApplicationArgs = {
  billingAccountId: Scalars['String'];
};


/** Root Query */
export type QueryIsEmailInAuth0Args = {
  email: Scalars['String'];
};


/** Root Query */
export type QueryPartnerByUserIdArgs = {
  userId: Scalars['ID'];
};


/** Root Query */
export type QueryPaymentFilesArgs = {
  ids: Array<Scalars['Int']>;
};


/** Root Query */
export type QueryPaymentFilesByUserIdArgs = {
  bucket: PaymentFileS3Bucket;
  uploadedByUserID: Scalars['String'];
};


/** Root Query */
export type QueryUserByIdArgs = {
  id: Scalars['ID'];
};

export type QuotePatchRequirement = {
  __typename?: 'QuotePatchRequirement';
  add_requirements: Maybe<Scalars['JSON']>;
  kind: Maybe<Scalars['String']>;
  menu: Maybe<Scalars['String']>;
  version: Maybe<Scalars['Int']>;
};

export type QuotePatchRequirementInput = {
  add_requirements: InputMaybe<Scalars['JSON']>;
  kind: InputMaybe<Scalars['String']>;
  menu: InputMaybe<Scalars['String']>;
  version: InputMaybe<Scalars['Int']>;
};

export type QuotePresetsInput = {
  menuId: InputMaybe<Scalars['String']>;
  patchRequirement: InputMaybe<QuotePatchRequirementInput>;
};

export type QuotePresetsUpdateInput = {
  id: Scalars['Int'];
  menuId: InputMaybe<Scalars['String']>;
  organizationId: InputMaybe<Scalars['Int']>;
  patchRequirement: InputMaybe<Scalars['JSON']>;
};

export type RefundPaymentReturn = {
  __typename?: 'RefundPaymentReturn';
  /** Human readable error message. Will only be populated if error is present */
  error: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  /** How much is left that needs to be captured */
  remainingCaptureAmount: Maybe<Scalars['Int']>;
  /** Was the refund payment successful */
  successful: Scalars['Boolean'];
};

export type RemoveBankAccountMutationResponse = MutationResponse & {
  __typename?: 'RemoveBankAccountMutationResponse';
  bankAccount: Maybe<BankAccount>;
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RemoveStripeCardMutationResponse = MutationResponse & {
  __typename?: 'RemoveStripeCardMutationResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  stripecard: Maybe<StripeCard>;
  success: Scalars['Boolean'];
};

export type SessionUser = {
  __typename?: 'SessionUser';
  /** accessControlPolicies */
  accessControlPolicies: Maybe<Array<Maybe<AccessControlPolicy>>>;
  /** email of the user */
  emailAddress: Maybe<Scalars['String']>;
  /** first name of the user */
  firstName: Maybe<Scalars['String']>;
  /** Id of the user. */
  id: Scalars['String'];
  /** last name of the user */
  lastName: Maybe<Scalars['String']>;
  /** Mfa method enabled by the user. */
  mfaMethod: Maybe<MfaMethods>;
  /** phone number of the user */
  phoneNumber: Maybe<Scalars['String']>;
  /** Did this user complete registration */
  registered: Maybe<Scalars['Boolean']>;
};


export type SessionUserAccessControlPoliciesArgs = {
  context: InputMaybe<ContextInput>;
};

export type SetAccountPermissionInput = {
  billingAccountId: Scalars['ID'];
  context: Context;
  permissions: Array<PermissionInput>;
  userId: Scalars['String'];
};

export type SetAccountPermissionResponse = {
  __typename?: 'SetAccountPermissionResponse';
  policy: AccessControlPolicy;
};

export type SetBillingAccountAddressInput = {
  address: BillingAccountAddressInput;
  billingAccountId: Scalars['ID'];
};

export type SetBillingAccountAddressResult = {
  __typename?: 'SetBillingAccountAddressResult';
  billingAccount: BillingAccount;
};

export type SetBillingAccountContactPerson = {
  /** The email address associated with the billing contact. This is also 'Account Payable' email */
  emailAddress: Scalars['String'];
  /** The billing contact's name as a single string (first name and last name) */
  name: Scalars['String'];
  /** The phone number associated with the billing contact */
  phoneNumber: Scalars['String'];
};

export type SetStatusInput = {
  status: InputMaybe<Scalars['String']>;
};

export type SetStatusPayload = {
  __typename?: 'SetStatusPayload';
  status: Maybe<Scalars['String']>;
};

export type SetUserPermissionInput = {
  context: Context;
  permissions: Array<PermissionInput>;
  userId: Scalars['String'];
};

export type SetUserPermissionResponse = {
  __typename?: 'SetUserPermissionResponse';
  policy: AccessControlPolicy;
};

/** A return type to indicate the success of any shipping account operation */
export type ShippingAccountMutationSuccess = {
  __typename?: 'ShippingAccountMutationSuccess';
  success: Scalars['Boolean'];
};

/** Stripe Card Details */
export type StripeCard = PaymentMethodInterface & {
  __typename?: 'StripeCard';
  /** Card Brand */
  brand: Scalars['String'];
  /** The expiration Month of the Card (MM) */
  expMonth: Scalars['String'];
  /** Expiration Year of the Card. (YYYY) */
  expYear: Scalars['String'];
  /** Primary Id */
  id: Scalars['ID'];
  /** The last four digits of the credit card number */
  last4: Scalars['String'];
  /** The name on the credit card */
  name: Maybe<Scalars['String']>;
  /** 'stripecard' */
  type: Scalars['String'];
};

export type TaxExemption = {
  __typename?: 'TaxExemption';
  /** TaxExemption number in CertCapture */
  TaxExemption_number: Maybe<Scalars['Int']>;
  /** Actual tax code for a given TaxExemption */
  actual_tax_code: Maybe<TaxExemptionSubObject>;
  /** Indicator for whether a TaxExemption includes a readable barcode */
  barcode_read: Maybe<Scalars['Boolean']>;
  /**
   * TaxExemption's customer number in CertCapture system
   * corresponds to the Billing Account ID in our system
   */
  billingAccountId: Scalars['String'];
  /** Billing Account Name associated with the TaxExemption */
  billingAccountName: Maybe<Scalars['String']>;
  /** Id for calculation done in CertCapture */
  calc_id: Maybe<Scalars['Int']>;
  /** TaxExemption's client number in CertCapture system */
  client_id: Maybe<Scalars['ID']>;
  /** Date TaxExemption was created in CertCapture */
  created: Maybe<Scalars['DateTime']>;
  /** Document type of TaxExemption in CertCapture */
  document_type: Maybe<TaxExemptionSubObject>;
  /** Percentage for tax exemption for a given TaxExemption */
  exmpt_percent: Maybe<Scalars['Int']>;
  /** Expected tax code for a given TaxExemption */
  expected_tax_code: Maybe<TaxExemptionSubObject>;
  /** Date indicating when a TaxExemption expires */
  expiration_date: Maybe<Scalars['DateTime']>;
  /** Zone of exposure (usually a state or territory) for a given TaxExemption */
  exposure_zone: Maybe<TaxExemptionSubObject>;
  /** Name of the file uploaded as the TaxExemption */
  filename: Maybe<Scalars['String']>;
  /** ID of the TaxExemption */
  id: Scalars['String'];
  /** Inidicator for whether a TaxExemption is singular */
  is_single: Maybe<Scalars['Boolean']>;
  /** Last modification date in CertCapture */
  modified: Maybe<Scalars['DateTime']>;
  /** Indicator for whether a TaxExemption can never renew in CertCapture */
  never_renew: Maybe<Scalars['Boolean']>;
  /** REST API endpoint for grabbing the attached PDF file */
  pdfUrl: Maybe<Scalars['String']>;
  /** Renewable indicator in CertCapture system */
  renewable: Maybe<Scalars['Boolean']>;
  /** Date signed on TaxExemption */
  signed_date: Maybe<Scalars['DateTime']>;
  /** Status of the TaxExemption within CertCapture */
  status: Maybe<TaxExemptionStatus>;
  /** Tax number for a TaxExemption */
  tax_number: Maybe<Scalars['String']>;
  /** Type of tax number */
  tax_number_type: Maybe<Scalars['String']>;
  /** Indicator for whether the tax exemption is an unused multi cert */
  unused_multi_cert: Maybe<Scalars['Boolean']>;
  /** Indicator for whether a TaxExemption is valid in CertCapture */
  valid: Maybe<Scalars['Boolean']>;
  /** Number of verification in CertCapture */
  verification_number: Maybe<Scalars['Int']>;
  /** Indicator for whether a TaxExemption was verified in CertCapture */
  verified: Maybe<Scalars['Boolean']>;
};

export type TaxExemptionCustomer = {
  /** Line one of customer address */
  address_line1: InputMaybe<Scalars['String']>;
  /** Line two of customer address */
  address_line2: InputMaybe<Scalars['String']>;
  /** City name of customer */
  city: InputMaybe<Scalars['String']>;
  /** CertCapture assigned customer_number. Should in all cases be the Billing Account ID number. */
  customer_number: InputMaybe<Scalars['ID']>;
  /** Name of Customer in CertCapture system. Should match the name of the Billing Account. Can be changed by accounting in CertCapture system. */
  name: InputMaybe<Scalars['String']>;
};

export type TaxExemptionStatus = {
  __typename?: 'TaxExemptionStatus';
  /** String returning status of TaxExemption in CertCapture. E.g. Expired */
  name: Maybe<Scalars['String']>;
};

export type TaxExemptionSubObject = {
  __typename?: 'TaxExemptionSubObject';
  /** ID for given subobject */
  id: Maybe<Scalars['ID']>;
  /** Name of a given subobject */
  name: Maybe<Scalars['String']>;
  /** Additional tags for a given subobject */
  tag: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  /** accessControlPolicies */
  accessControlPolicies: Maybe<Array<Maybe<AccessControlPolicy>>>;
  /** List of billing accounts to which user has access */
  billingAccounts: Maybe<UserBillingAccountConnection>;
  /** email of the user */
  emailAddress: Maybe<Scalars['String']>;
  /** first name of the user */
  firstName: Maybe<Scalars['String']>;
  /** Id of the user. */
  id: Scalars['String'];
  /** last name of the user */
  lastName: Maybe<Scalars['String']>;
  /** Mfa method enabled by the user. */
  mfaMethod: Maybe<MfaMethods>;
  /** phone number of the user */
  phoneNumber: Maybe<Scalars['String']>;
  /** Did this user complete registration */
  registered: Maybe<Scalars['Boolean']>;
};


export type UserAccessControlPoliciesArgs = {
  context: InputMaybe<ContextInput>;
};


export type UserBillingAccountsArgs = {
  page: InputMaybe<PageInput>;
};

export type UserBillingAccountConnection = Connection & {
  __typename?: 'UserBillingAccountConnection';
  edges: Maybe<Array<Maybe<UserBillingAccountEdge>>>;
  pageInfo: Maybe<PageInfo>;
};

export type UserBillingAccountEdge = Edge & {
  __typename?: 'UserBillingAccountEdge';
  cursor: Scalars['String'];
  node: Maybe<BillingAccount>;
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  /** Url of the invitation. */
  inviteUrl: Scalars['String'];
  /** Email of the inviter. */
  inviterEmail: Maybe<Scalars['String']>;
  /** Name of the partner. */
  partnerName: Scalars['String'];
};

export type UserSubmittedApplication = {
  __typename?: 'UserSubmittedApplication';
  /** The date the application was submitted */
  date: Maybe<Scalars['DateTime']>;
  /** The application submit status */
  isSubmitted: Maybe<Scalars['Boolean']>;
};

export const FullOrganization = gql`
    fragment FullOrganization on Organization {
  id
  refId
  name
  legalName
  ein
  duns
  path
  isArchived
  availableRoles {
    id
    name
    permissions {
      id
      name
      description
    }
  }
}
    `;
export const FullOrganizationUser = gql`
    fragment FullOrganizationUser on OrganizationUser {
  id
  userId
  organizationId
  date
  federatedUser {
    federatedIdentity {
      id
      linkedWith {
        application
        federatedIdentityId
        userId
      }
    }
    userData {
      firstName
      lastName
      email
    }
  }
  permissions {
    id
    name
    description
  }
  role {
    id
    name
    permissions {
      id
      name
      description
    }
  }
}
    `;
export const FullOrganizationInvitation = gql`
    fragment FullOrganizationInvitation on OrganizationInvitation {
  id
  date
  status
  userData {
    firstName
    lastName
    email
  }
  role {
    id
    name
  }
  senderUserData {
    firstName
    lastName
    email
  }
  acceptInviteUrl
  declineInviteUrl
  organization {
    name
    activeMembers
    id
  }
}
    `;
export const CreateBillingAccountQuery = gql`
    mutation createBillingAccount($input: CreateBillingAccountInput!) {
  createBillingAccount(input: $input) {
    billingAccount {
      id
      name
      apEmailAddress
      contact {
        name
        emailAddress
        phoneNumber
        address {
          street1
          street2
          city
          state
          zipcode
          country
        }
      }
    }
  }
}
    `;
export const SetBillingAccountAddressQuery = gql`
    mutation setBillingAccountAddress($input: SetBillingAccountAddressInput!) {
  setBillingAccountAddress(input: $input) {
    billingAccount {
      id
      contact {
        address {
          street1
          street2
          city
          state
          zipcode
          country
        }
      }
    }
  }
}
    `;
export const DeleteTaxExemptionQuery = gql`
    mutation deleteTaxExemption($input: DeleteTaxExemptionInput!) {
  deleteTaxExemption(input: $input)
}
    `;
export const AddTaxExemptionUrlQuery = gql`
    mutation addTaxExemptionUrl($input: AddTaxExemptionInput!) {
  addTaxExemptionUrl(input: $input)
}
    `;
export const CreateCreditApplicationQuery = gql`
    mutation createCreditApplication($input: CreateCreditApplicationInput!) {
  createCreditApplication(input: $input) {
    id
    billingAccountId
    acctsPayableEmail
    requestedTermLimit
    approvedAmount
    decision
  }
}
    `;
export const GetOrganizationByIdQuery = gql`
    query getOrganizationById($id: ID!) {
  getOrganizationById(id: $id) {
    ...FullOrganization
  }
}
    ${FullOrganization}`;
export const GetOrganizationUsersQuery = gql`
    query getOrganizationUsers($orgId: ID!) {
  getOrganizationUsers(orgId: $orgId) {
    ...FullOrganizationUser
  }
}
    ${FullOrganizationUser}`;
export const GetOrganizationsQuery = gql`
    query getOrganizations($pageNum: Int!, $pageSize: Int) {
  getOrganizations(pageNum: $pageNum, pageSize: $pageSize) {
    ...FullOrganization
  }
}
    ${FullOrganization}`;
export const GetUsersOrganizationsByIdentityQuery = gql`
    query getUsersOrganizationsByIdentity($application: String!, $userId: String!, $isArchived: Boolean) {
  getUsersOrganizationsByIdentity(
    application: $application
    userId: $userId
    isArchived: $isArchived
  ) {
    id
    name
    activeMembers
    isArchived
    availableRoles {
      id
      name
      permissions {
        id
        name
        description
      }
    }
  }
}
    `;
export const GetUsersOrganizationsQuery = gql`
    query getUsersOrganizations {
  getUsersOrganizations {
    ...FullOrganization
  }
}
    ${FullOrganization}`;
export const GetOrganizationInvitationsQuery = gql`
    query getOrganizationInvitations($orgId: ID!) {
  getOrganizationInvitations(orgId: $orgId) {
    ...FullOrganizationInvitation
  }
}
    ${FullOrganizationInvitation}`;
export const GetOrganizationEventsQuery = gql`
    query getOrganizationEvents($orgId: ID!) {
  getOrganizationEvents(orgId: $orgId) {
    id
    type
    date
    organizationId
    actor {
      userId
      email
      firstName
      lastName
    }
    actorIsStaff
    affectedMembers {
      firstName
      lastName
      email
    }
    eventData
  }
}
    `;
export const GetOrganizationInvitationsByEmailQuery = gql`
    query getOrganizationInvitationsByEmail($email: String!) {
  getOrganizationInvitationsByEmail(email: $email) {
    ...FullOrganizationInvitation
  }
}
    ${FullOrganizationInvitation}`;
export const GetOrganizationUserPermissionsForMeQuery = gql`
    query getOrganizationUserPermissionsForMe($orgId: ID!) {
  getOrganizationUserPermissionsForMe(orgId: $orgId) {
    id
    name
    description
  }
}
    `;
export const GetOrganizationShippingAccountsByOrganizationIdQuery = gql`
    query GetOrganizationShippingAccountsByOrganizationId($organizationId: ID!) {
  getOrganizationShippingAccountsByOrganizationId(organizationId: $organizationId) {
    id
    provider
    accountNumber
    isTeamDefault
    organizationId
    isDeleted
  }
}
    `;
export const GetOrganizationShippingAddressesByOrganizationIdQuery = gql`
    query getOrganizationShippingAddressesByOrganizationId($organizationId: ID!) {
  getOrganizationShippingAddressesByOrganizationId(
    organizationId: $organizationId
  ) {
    id
    name
    street1
    street2
    city
    state
    zipcode
    countryCode
    isDeleted
    emailAddress
    phoneNumber
    isTeamDefault
    validated
    validationExempt
  }
}
    `;
export const GetOrganizationDefaultsByOrganizationIdsQuery = gql`
    query getOrganizationDefaultsByOrganizationIds($organizationIds: [ID]!) {
  getOrganizationDefaultsByOrganizationIds(organizationIds: $organizationIds) {
    organization {
      id
      refId
      name
      legalName
      path
      ein
      duns
      isArchived
      activeMembers
    }
    quotePresets {
      id
      menuId
      organizationId
      createdAt
      updatedAt
      patchRequirement
      invalidRequirement
      updatedBy {
        userId
        firstName
        lastName
        email
      }
    }
  }
}
    `;
export const AcceptOrganizationInviteQuery = gql`
    mutation acceptOrganizationInvite($orgId: ID!, $acceptInvite: Boolean!) {
  acceptOrganizationInvite(orgId: $orgId, acceptInvite: $acceptInvite) {
    success
  }
}
    `;
export const DeleteInvitationForOrganizationQuery = gql`
    mutation deleteInvitationForOrganization($orgId: ID!, $memberEmail: String!) {
  deleteInvitationForOrganization(orgId: $orgId, memberEmail: $memberEmail) {
    success
  }
}
    `;
export const SendOrganizationInvitationsQuery = gql`
    mutation sendOrganizationInvitations($addUsersInput: OrganizationUsersByEmailsInput!) {
  sendOrganizationInvitations(addUsersInput: $addUsersInput) {
    email
    acceptInviteUrl
    declineInviteUrl
    emailStatusCode
    emailStatusMessage
  }
}
    `;
export const UpdateOrganizationInvitationRolesQuery = gql`
    mutation updateOrganizationInvitationRoles($orgId: ID!, $emails: [String!]!, $roleId: ID!) {
  updateOrganizationInvitationRoles(
    orgId: $orgId
    emails: $emails
    roleId: $roleId
  ) {
    ...FullOrganizationInvitation
  }
}
    ${FullOrganizationInvitation}`;
export const CreateOrganizationQuery = gql`
    mutation createOrganization($name: String!, $legalName: String, $path: String, $ein: String, $duns: String) {
  createOrganization(
    organization: {name: $name, legalName: $legalName, path: $path, ein: $ein, duns: $duns}
  ) {
    ...FullOrganization
  }
}
    ${FullOrganization}`;
export const UpdateOrganizationByIdQuery = gql`
    mutation updateOrganizationById($id: ID!, $organization: OrganizationUpdateInput!) {
  updateOrganizationById(id: $id, organization: $organization) {
    id
    name
    legalName
    path
    ein
    duns
  }
}
    `;
export const UpdateOrganizationMemberRoleByMemberIdQuery = gql`
    mutation updateOrganizationMemberRoleByMemberId($orgId: ID!, $memberId: ID!, $roleId: ID!) {
  updateOrganizationMemberRoleByMemberId(
    orgId: $orgId
    memberId: $memberId
    roleId: $roleId
  ) {
    ...FullOrganizationUser
  }
}
    ${FullOrganizationUser}`;
export const RemoveOrganizationUsersQuery = gql`
    mutation removeOrganizationUsers($orgId: ID!, $memberIds: [ID!]!) {
  removeOrganizationUsers(orgId: $orgId, memberIds: $memberIds) {
    success
  }
}
    `;
export const UpdateOrganizationIsArchivedQuery = gql`
    mutation updateOrganizationIsArchived($orgId: ID!, $isArchived: Boolean!) {
  updateOrganizationIsArchived(orgId: $orgId, isArchived: $isArchived) {
    ...FullOrganization
  }
}
    ${FullOrganization}`;
export const CreateOrganizationShippingAccountQuery = gql`
    mutation createOrganizationShippingAccount($shippingAccount: OrganizationShippingAccountInput!) {
  createOrganizationShippingAccount(shippingAccount: $shippingAccount) {
    id
    provider
    accountNumber
    isTeamDefault
    organizationId
  }
}
    `;
export const DeleteOrganizationShippingAccountByIdQuery = gql`
    mutation deleteOrganizationShippingAccountById($id: ID!, $organizationId: ID!) {
  deleteOrganizationShippingAccountById(id: $id, organizationId: $organizationId) {
    success
  }
}
    `;
export const CreateOrganizationShippingAddressQuery = gql`
    mutation createOrganizationShippingAddress($shippingAddress: OrganizationShippingAddressInput!) {
  createOrganizationShippingAddress(shippingAddress: $shippingAddress) {
    name
    street1
    street2
    city
    state
    zipcode
    countryCode
    organizationId
    emailAddress
    phoneNumber
    validated
    isTeamDefault
    validationExempt
  }
}
    `;
export const DeleteOrganizationShippingAddressByIdQuery = gql`
    mutation deleteOrganizationShippingAddressById($id: ID!, $organizationId: ID!) {
  deleteOrganizationShippingAddressById(id: $id, organizationId: $organizationId) {
    success
  }
}
    `;
export const UpdateOrganizationShippingAddressByIdQuery = gql`
    mutation updateOrganizationShippingAddressById($id: ID!, $organizationId: ID!, $shippingAddress: OrganizationShippingAddressUpdateInput!) {
  updateOrganizationShippingAddressById(
    id: $id
    organizationId: $organizationId
    shippingAddress: $shippingAddress
  ) {
    name
    street1
    street2
    city
    state
    zipcode
    countryCode
    organizationId
    emailAddress
    phoneNumber
    validated
    isTeamDefault
    validationExempt
  }
}
    `;
export const UpdateOrganizationShippingAccountByIdQuery = gql`
    mutation updateOrganizationShippingAccountById($id: ID!, $organizationId: ID!, $shippingAccount: OrganizationShippingAccountUpdateInput!) {
  updateOrganizationShippingAccountById(
    id: $id
    organizationId: $organizationId
    shippingAccount: $shippingAccount
  ) {
    id
    provider
    accountNumber
    isTeamDefault
    organizationId
  }
}
    `;
export const CreateOrganizationQuotePresetQuery = gql`
    mutation createOrganizationQuotePreset($orgId: ID!, $menuId: String!, $quotePresets: QuotePresetsInput!) {
  createOrganizationQuotePreset(
    OrgId: $orgId
    MenuId: $menuId
    QuotePresets: $quotePresets
  ) {
    id
    refId
    name
    legalName
    path
    isArchived
    activeMembers
    quotePresets {
      menuId
      patchRequirement
    }
  }
}
    `;
export const UpdateOrganizationQuotePresetQuery = gql`
    mutation UpdateOrganizationQuotePreset($orgId: ID!, $menuId: String!, $quotePresets: QuotePresetsUpdateInput!) {
  updateOrganizationQuotePreset(
    OrgId: $orgId
    MenuId: $menuId
    QuotePresets: $quotePresets
  ) {
    id
    refId
    name
    legalName
    path
    isArchived
    activeMembers
    quotePresets {
      menuId
      patchRequirement
    }
  }
}
    `;
export const DeleteOrganizationQuotePresetQuery = gql`
    mutation deleteOrganizationQuotePreset($orgId: ID!, $quotePresetId: Int!) {
  deleteOrganizationQuotePreset(OrgId: $orgId, OrgQuotePresetId: $quotePresetId) {
    id
    refId
    name
    legalName
    path
    isArchived
    activeMembers
    quotePresets {
      menuId
      patchRequirement
    }
  }
}
    `;
export const PaymentMethodsQuery = gql`
    query paymentMethods {
  paymentMethods {
    ... on StripeCard {
      id
      type
      brand
      expMonth
      expYear
      last4
      name
    }
    ... on MSTS {
      id
      type
      status
      creditLimit
      creditUsed
      creditHeld
      businessName
    }
    ... on AvailableBalance {
      id
      type
      availableBalance
    }
    ... on BankAccount {
      id
      type
      bankName
      last4
      status
      accountHolderName
    }
  }
}
    `;
export const GetLinkTokenQuery = gql`
    query getLinkToken {
  getLinkToken {
    token
  }
}
    `;
export const PaymentActionsByCheckoutIdentifierQuery = gql`
    query paymentActionsByCheckoutIdentifier($checkoutIdentifier: String!) {
  authorizationsByCheckoutIdentifier(checkoutIdentifier: $checkoutIdentifier) {
    amount
    methodType
    methodId
    createdAt
    successful
    paymentMethod {
      ... on StripeCard {
        id
        type
        brand
        expMonth
        expYear
        last4
        name
      }
      ... on MSTS {
        id
        type
        status
        creditLimit
        creditUsed
        creditHeld
        businessName
      }
      ... on AvailableBalance {
        id
        type
        availableBalance
      }
      ... on BankAccount {
        id
        type
        bankName
        last4
        status
        accountHolderName
      }
    }
  }
  captures(capturesFilters: {checkoutIdentifier: $checkoutIdentifier}) {
    amount
    methodType
    methodId
    createdAt
    successful
    paymentMethod {
      ... on StripeCard {
        id
        type
        brand
        expMonth
        expYear
        last4
        name
      }
      ... on MSTS {
        id
        type
        status
        creditLimit
        creditUsed
        creditHeld
        businessName
      }
      ... on AvailableBalance {
        id
        type
        availableBalance
      }
      ... on BankAccount {
        id
        type
        bankName
        last4
        status
        accountHolderName
      }
    }
  }
}
    `;
export const AddStripeCardQuery = gql`
    mutation addStripeCard($token: String!) {
  addStripeCard(token: $token) {
    ... on StripeCard {
      id
    }
  }
}
    `;
export const RemoveStripeCardQuery = gql`
    mutation removeStripeCard($cardId: String!) {
  removeStripeCard(cardId: $cardId) {
    ... on RemoveStripeCardMutationResponse {
      code
      success
      message
    }
  }
}
    `;
export const AddBankAccountQuery = gql`
    mutation addBankAccount($token: String!, $accountIds: [String!]!) {
  addBankAccount(token: $token, accountIds: $accountIds) {
    ... on BankAccount {
      id
    }
  }
}
    `;
export const RemoveBankAccountQuery = gql`
    mutation removeBankAccount($accountId: String!) {
  removeBankAccount(accountId: $accountId) {
    ... on RemoveBankAccountMutationResponse {
      code
      success
      message
    }
  }
}
    `;
export const CheckoutQuery = gql`
    mutation checkout($checkoutIdentifier: String!, $paymentMethodId: ID!, $paymentMethodType: String!, $lineItems: [PaymentCaptureLineItemInput!]!, $amount: Int, $description: String!, $callbackMutation: String) {
  checkout(
    checkoutIdentifier: $checkoutIdentifier
    paymentMethodId: $paymentMethodId
    paymentMethodType: $paymentMethodType
    lineItems: $lineItems
    amount: $amount
    description: $description
    callbackMutation: $callbackMutation
  ) {
    successful
  }
}
    `;
export const UploadPaymentFileQuery = gql`
    mutation uploadPaymentFile($file: Upload!, $acls: [PaymentFileACL!]!, $bucket: PaymentFileS3Bucket, $userFileAttributes: String) {
  uploadPaymentFile(
    file: $file
    acls: $acls
    bucket: $bucket
    userFileAttributes: $userFileAttributes
  ) {
    id
  }
}
    `;
export const UploadPaymentFilesQuery = gql`
    mutation uploadPaymentFiles($files: [Upload!]!, $acls: [PaymentFileACL!]!, $bucket: PaymentFileS3Bucket, $userFileAttributes: [String]) {
  uploadPaymentFiles(
    files: $files
    acls: $acls
    bucket: $bucket
    userFileAttributes: $userFileAttributes
  ) {
    id
  }
}
    `;
export const GetBillingAccountUserQuery = gql`
    query getBillingAccountUser($userId: String!) {
  getBillingAccountUser(userId: $userId) {
    billingAccounts {
      edges {
        node {
          id
          createdBy
          name
          creditLimitInCents
          availableCreditInCents
          creditTerm
          status
          contact {
            name
            phoneNumber
            emailAddress
            address {
              street1
              street2
              city
              state
              province
              zipcode
              country
            }
          }
        }
      }
    }
  }
}
    `;
export const GetTaxExemptionsQuery = gql`
    query getTaxExemptions($userId: String!) {
  getTaxExemptions(userId: $userId) {
    id
    client_id
    billingAccountId
    pdfUrl
    document_type {
      name
    }
    actual_tax_code {
      name
    }
    expected_tax_code {
      name
    }
    exposure_zone {
      name
    }
    status {
      name
    }
    filename
    expiration_date
    signed_date
    billingAccountName
  }
}
    `;
export const PartnerByUserIdQuery = gql`
    query partnerByUserId($userId: ID!) {
  partnerByUserId(userId: $userId) {
    partner {
      id
    }
  }
}
    `;
export const HasUserSubmittedApplicationQuery = gql`
    query hasUserSubmittedApplication($billingAccountId: String!) {
  hasUserSubmittedApplication(billingAccountId: $billingAccountId) {
    isSubmitted
    date
  }
}
    `;
export const UserByIdQuery = gql`
    query userById($id: ID!) {
  userById(id: $id) {
    firstName
    lastName
    emailAddress
    id
    registered
  }
}
    `;
export const GetLoggedInUserQuery = gql`
    query getLoggedInUser {
  me {
    firstName
    lastName
    emailAddress
    id
    registered
  }
}
    `;
export const UserInvitationsQuery = gql`
    query userInvitations {
  userInvitations {
    inviteUrl
    partnerName
    inviterEmail
  }
}
    `;
export const GetBillingAccountFinancialsQuery = gql`
    query getBillingAccountFinancials($input: GetBillingAccountInput!) {
  getBillingAccount(input: $input) {
    id
    name
    invoices {
      recordNo
      docNo
      whenCreated
      whenDue
      totalEntered
      totalDue
      state
      currency
      paymentProcessingStatus
    }
    payments {
      recordNo
      customerId
      whenCreated
      totalEntered
      unusedAmount
      currency
      allocations {
        invoiceRecordNo
        amountApplied
      }
    }
    creditMemos {
      recordNo
      docNo
      whenCreated
      totalEntered
      totalDue
      state
      currency
      description
    }
  }
}
    `;
export const PayInvoicesQuery = gql`
    mutation payInvoices($input: InvoicePaymentInput!) {
  payInvoices(input: $input) {
    successful
    chargeId
    errorMessage
  }
}
    `;
export const UserAcceptTosQuery = gql`
    mutation userAcceptTos($id: ID!, $vendor: Boolean) {
  userAcceptTos(id: $id, vendor: $vendor)
}
    `;
export const IsEmailInAuth0Query = gql`
    query isEmailInAuth0($email: String!) {
  isEmailInAuth0(email: $email)
}
    `;
export type CreateBillingAccountMutationVariables = Exact<{
  input: CreateBillingAccountInput;
}>;


export type CreateBillingAccountMutationResult = { __typename?: 'Mutation', createBillingAccount: { __typename?: 'CreateBillingAccountResult', billingAccount: { __typename?: 'BillingAccount', id: string, name: string, apEmailAddress: string | null, contact: { __typename?: 'BillingAccountContact', name: string, emailAddress: string, phoneNumber: string, address: { __typename?: 'BillingAccountAddress', street1: string, street2: string | null, city: string, state: string | null, zipcode: string | null, country: string } | null } | null } } | null };

export type SetBillingAccountAddressMutationVariables = Exact<{
  input: SetBillingAccountAddressInput;
}>;


export type SetBillingAccountAddressMutationResult = { __typename?: 'Mutation', setBillingAccountAddress: { __typename?: 'SetBillingAccountAddressResult', billingAccount: { __typename?: 'BillingAccount', id: string, contact: { __typename?: 'BillingAccountContact', address: { __typename?: 'BillingAccountAddress', street1: string, street2: string | null, city: string, state: string | null, zipcode: string | null, country: string } | null } | null } } | null };

export type DeleteTaxExemptionMutationVariables = Exact<{
  input: DeleteTaxExemptionInput;
}>;


export type DeleteTaxExemptionMutationResult = { __typename?: 'Mutation', deleteTaxExemption: boolean | null };

export type AddTaxExemptionUrlMutationVariables = Exact<{
  input: AddTaxExemptionInput;
}>;


export type AddTaxExemptionUrlMutationResult = { __typename?: 'Mutation', addTaxExemptionUrl: string | null };

export type CreateCreditApplicationMutationVariables = Exact<{
  input: CreateCreditApplicationInput;
}>;


export type CreateCreditApplicationMutationResult = { __typename?: 'Mutation', createCreditApplication: { __typename?: 'CreateCreditApplicationResponse', id: number | null, billingAccountId: string | null, acctsPayableEmail: string | null, requestedTermLimit: string | null, approvedAmount: number | null, decision: string | null } | null };

export type FullOrganizationFragment = { __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, ein: string | null, duns: string | null, path: string | null, isArchived: boolean | null, availableRoles: Array<{ __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> }> };

export type FullOrganizationUserFragment = { __typename?: 'OrganizationUser', id: string, userId: string | null, organizationId: string, date: any, federatedUser: { __typename?: 'OrganizationFederatedUser', federatedIdentity: { __typename?: 'FederatedIdentity', id: number, linkedWith: Array<{ __typename?: 'ApplicationUser', application: string, federatedIdentityId: number | null, userId: string }> } | null, userData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null } | null, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null } | null>, role: { __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> } };

export type FullOrganizationInvitationFragment = { __typename?: 'OrganizationInvitation', id: string, date: any, status: string, acceptInviteUrl: string | null, declineInviteUrl: string | null, userData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null, role: { __typename?: 'OrganizationRole', id: string, name: string } | null, senderUserData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null, organization: { __typename?: 'Organization', name: string, activeMembers: number | null, id: string } };

export type GetOrganizationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationByIdQueryResult = { __typename?: 'Query', getOrganizationById: { __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, ein: string | null, duns: string | null, path: string | null, isArchived: boolean | null, availableRoles: Array<{ __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> }> } };

export type GetOrganizationUsersQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type GetOrganizationUsersQueryResult = { __typename?: 'Query', getOrganizationUsers: Array<{ __typename?: 'OrganizationUser', id: string, userId: string | null, organizationId: string, date: any, federatedUser: { __typename?: 'OrganizationFederatedUser', federatedIdentity: { __typename?: 'FederatedIdentity', id: number, linkedWith: Array<{ __typename?: 'ApplicationUser', application: string, federatedIdentityId: number | null, userId: string }> } | null, userData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null } | null, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null } | null>, role: { __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> } } | null> };

export type GetOrganizationsQueryVariables = Exact<{
  pageNum: Scalars['Int'];
  pageSize: InputMaybe<Scalars['Int']>;
}>;


export type GetOrganizationsQueryResult = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, ein: string | null, duns: string | null, path: string | null, isArchived: boolean | null, availableRoles: Array<{ __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> }> } | null> };

export type GetUsersOrganizationsByIdentityQueryVariables = Exact<{
  application: Scalars['String'];
  userId: Scalars['String'];
  isArchived: InputMaybe<Scalars['Boolean']>;
}>;


export type GetUsersOrganizationsByIdentityQueryResult = { __typename?: 'Query', getUsersOrganizationsByIdentity: Array<{ __typename?: 'Organization', id: string, name: string, activeMembers: number | null, isArchived: boolean | null, availableRoles: Array<{ __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> }> }> };

export type GetUsersOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersOrganizationsQueryResult = { __typename?: 'Query', getUsersOrganizations: Array<{ __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, ein: string | null, duns: string | null, path: string | null, isArchived: boolean | null, availableRoles: Array<{ __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> }> } | null> };

export type GetOrganizationInvitationsQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type GetOrganizationInvitationsQueryResult = { __typename?: 'Query', getOrganizationInvitations: Array<{ __typename?: 'OrganizationInvitation', id: string, date: any, status: string, acceptInviteUrl: string | null, declineInviteUrl: string | null, userData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null, role: { __typename?: 'OrganizationRole', id: string, name: string } | null, senderUserData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null, organization: { __typename?: 'Organization', name: string, activeMembers: number | null, id: string } } | null> };

export type GetOrganizationEventsQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type GetOrganizationEventsQueryResult = { __typename?: 'Query', getOrganizationEvents: Array<{ __typename?: 'OrganizationEvent', id: string, type: string, date: any, organizationId: string, actorIsStaff: boolean, eventData: any | null, actor: { __typename?: 'OrganizationUserData', userId: string | null, email: string | null, firstName: string | null, lastName: string | null }, affectedMembers: Array<{ __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null }> }> };

export type GetOrganizationInvitationsByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetOrganizationInvitationsByEmailQueryResult = { __typename?: 'Query', getOrganizationInvitationsByEmail: Array<{ __typename?: 'OrganizationInvitation', id: string, date: any, status: string, acceptInviteUrl: string | null, declineInviteUrl: string | null, userData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null, role: { __typename?: 'OrganizationRole', id: string, name: string } | null, senderUserData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null, organization: { __typename?: 'Organization', name: string, activeMembers: number | null, id: string } }> };

export type GetOrganizationUserPermissionsForMeQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type GetOrganizationUserPermissionsForMeQueryResult = { __typename?: 'Query', getOrganizationUserPermissionsForMe: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null } | null> };

export type GetOrganizationShippingAccountsByOrganizationIdQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetOrganizationShippingAccountsByOrganizationIdQueryResult = { __typename?: 'Query', getOrganizationShippingAccountsByOrganizationId: Array<{ __typename?: 'OrganizationShippingAccount', id: string, provider: string, accountNumber: string, isTeamDefault: boolean, organizationId: string, isDeleted: boolean } | null> };

export type GetOrganizationShippingAddressesByOrganizationIdQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetOrganizationShippingAddressesByOrganizationIdQueryResult = { __typename?: 'Query', getOrganizationShippingAddressesByOrganizationId: Array<{ __typename?: 'OrganizationShippingAddress', id: string, name: string, street1: string, street2: string | null, city: string, state: string, zipcode: string, countryCode: string, isDeleted: boolean, emailAddress: string, phoneNumber: string, isTeamDefault: boolean, validated: boolean, validationExempt: boolean } | null> };

export type GetOrganizationDefaultsByOrganizationIdsQueryVariables = Exact<{
  organizationIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type GetOrganizationDefaultsByOrganizationIdsQueryResult = { __typename?: 'Query', getOrganizationDefaultsByOrganizationIds: Array<{ __typename?: 'OrganizationDefault', organization: { __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, path: string | null, ein: string | null, duns: string | null, isArchived: boolean | null, activeMembers: number | null } | null, quotePresets: Array<{ __typename?: 'OrganizationQuotePreset', id: string, menuId: string, organizationId: string, createdAt: any | null, updatedAt: any | null, patchRequirement: any | null, invalidRequirement: string | null, updatedBy: { __typename?: 'OrganizationUserData', userId: string | null, firstName: string | null, lastName: string | null, email: string | null } | null }> } | null> };

export type AcceptOrganizationInviteMutationVariables = Exact<{
  orgId: Scalars['ID'];
  acceptInvite: Scalars['Boolean'];
}>;


export type AcceptOrganizationInviteMutationResult = { __typename?: 'Mutation', acceptOrganizationInvite: { __typename?: 'OrganizationMutationSuccess', success: boolean } };

export type DeleteInvitationForOrganizationMutationVariables = Exact<{
  orgId: Scalars['ID'];
  memberEmail: Scalars['String'];
}>;


export type DeleteInvitationForOrganizationMutationResult = { __typename?: 'Mutation', deleteInvitationForOrganization: { __typename?: 'OrganizationMutationSuccess', success: boolean } };

export type SendOrganizationInvitationsMutationVariables = Exact<{
  addUsersInput: OrganizationUsersByEmailsInput;
}>;


export type SendOrganizationInvitationsMutationResult = { __typename?: 'Mutation', sendOrganizationInvitations: Array<{ __typename?: 'OrganizationInvitationResponse', email: string, acceptInviteUrl: string | null, declineInviteUrl: string | null, emailStatusCode: number | null, emailStatusMessage: string | null }> };

export type UpdateOrganizationInvitationRolesMutationVariables = Exact<{
  orgId: Scalars['ID'];
  emails: Array<Scalars['String']> | Scalars['String'];
  roleId: Scalars['ID'];
}>;


export type UpdateOrganizationInvitationRolesMutationResult = { __typename?: 'Mutation', updateOrganizationInvitationRoles: Array<{ __typename?: 'OrganizationInvitation', id: string, date: any, status: string, acceptInviteUrl: string | null, declineInviteUrl: string | null, userData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null, role: { __typename?: 'OrganizationRole', id: string, name: string } | null, senderUserData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null, organization: { __typename?: 'Organization', name: string, activeMembers: number | null, id: string } }> };

export type CreateOrganizationMutationVariables = Exact<{
  name: Scalars['String'];
  legalName: InputMaybe<Scalars['String']>;
  path: InputMaybe<Scalars['String']>;
  ein: InputMaybe<Scalars['String']>;
  duns: InputMaybe<Scalars['String']>;
}>;


export type CreateOrganizationMutationResult = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, ein: string | null, duns: string | null, path: string | null, isArchived: boolean | null, availableRoles: Array<{ __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> }> } };

export type UpdateOrganizationByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  organization: OrganizationUpdateInput;
}>;


export type UpdateOrganizationByIdMutationResult = { __typename?: 'Mutation', updateOrganizationById: { __typename?: 'Organization', id: string, name: string, legalName: string | null, path: string | null, ein: string | null, duns: string | null } };

export type UpdateOrganizationMemberRoleByMemberIdMutationVariables = Exact<{
  orgId: Scalars['ID'];
  memberId: Scalars['ID'];
  roleId: Scalars['ID'];
}>;


export type UpdateOrganizationMemberRoleByMemberIdMutationResult = { __typename?: 'Mutation', updateOrganizationMemberRoleByMemberId: { __typename?: 'OrganizationUser', id: string, userId: string | null, organizationId: string, date: any, federatedUser: { __typename?: 'OrganizationFederatedUser', federatedIdentity: { __typename?: 'FederatedIdentity', id: number, linkedWith: Array<{ __typename?: 'ApplicationUser', application: string, federatedIdentityId: number | null, userId: string }> } | null, userData: { __typename?: 'OrganizationUserData', firstName: string | null, lastName: string | null, email: string | null } | null } | null, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null } | null>, role: { __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> } } };

export type RemoveOrganizationUsersMutationVariables = Exact<{
  orgId: Scalars['ID'];
  memberIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveOrganizationUsersMutationResult = { __typename?: 'Mutation', removeOrganizationUsers: { __typename?: 'OrganizationMutationSuccess', success: boolean } };

export type UpdateOrganizationIsArchivedMutationVariables = Exact<{
  orgId: Scalars['ID'];
  isArchived: Scalars['Boolean'];
}>;


export type UpdateOrganizationIsArchivedMutationResult = { __typename?: 'Mutation', updateOrganizationIsArchived: { __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, ein: string | null, duns: string | null, path: string | null, isArchived: boolean | null, availableRoles: Array<{ __typename?: 'OrganizationRole', id: string, name: string, permissions: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, description: string | null }> }> } };

export type CreateOrganizationShippingAccountMutationVariables = Exact<{
  shippingAccount: OrganizationShippingAccountInput;
}>;


export type CreateOrganizationShippingAccountMutationResult = { __typename?: 'Mutation', createOrganizationShippingAccount: { __typename?: 'OrganizationShippingAccount', id: string, provider: string, accountNumber: string, isTeamDefault: boolean, organizationId: string } };

export type DeleteOrganizationShippingAccountByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
}>;


export type DeleteOrganizationShippingAccountByIdMutationResult = { __typename?: 'Mutation', deleteOrganizationShippingAccountById: { __typename?: 'ShippingAccountMutationSuccess', success: boolean } };

export type CreateOrganizationShippingAddressMutationVariables = Exact<{
  shippingAddress: OrganizationShippingAddressInput;
}>;


export type CreateOrganizationShippingAddressMutationResult = { __typename?: 'Mutation', createOrganizationShippingAddress: { __typename?: 'OrganizationShippingAddress', name: string, street1: string, street2: string | null, city: string, state: string, zipcode: string, countryCode: string, organizationId: string, emailAddress: string, phoneNumber: string, validated: boolean, isTeamDefault: boolean, validationExempt: boolean } };

export type DeleteOrganizationShippingAddressByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
}>;


export type DeleteOrganizationShippingAddressByIdMutationResult = { __typename?: 'Mutation', deleteOrganizationShippingAddressById: { __typename?: 'OrganizationShippingAddressMutationSuccess', success: boolean } };

export type UpdateOrganizationShippingAddressByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  shippingAddress: OrganizationShippingAddressUpdateInput;
}>;


export type UpdateOrganizationShippingAddressByIdMutationResult = { __typename?: 'Mutation', updateOrganizationShippingAddressById: { __typename?: 'OrganizationShippingAddress', name: string, street1: string, street2: string | null, city: string, state: string, zipcode: string, countryCode: string, organizationId: string, emailAddress: string, phoneNumber: string, validated: boolean, isTeamDefault: boolean, validationExempt: boolean } };

export type UpdateOrganizationShippingAccountByIdMutationVariables = Exact<{
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  shippingAccount: OrganizationShippingAccountUpdateInput;
}>;


export type UpdateOrganizationShippingAccountByIdMutationResult = { __typename?: 'Mutation', updateOrganizationShippingAccountById: { __typename?: 'OrganizationShippingAccount', id: string, provider: string, accountNumber: string, isTeamDefault: boolean, organizationId: string } };

export type CreateOrganizationQuotePresetMutationVariables = Exact<{
  orgId: Scalars['ID'];
  menuId: Scalars['String'];
  quotePresets: QuotePresetsInput;
}>;


export type CreateOrganizationQuotePresetMutationResult = { __typename?: 'Mutation', createOrganizationQuotePreset: { __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, path: string | null, isArchived: boolean | null, activeMembers: number | null, quotePresets: Array<{ __typename?: 'OrganizationQuotePreset', menuId: string, patchRequirement: any | null }> } };

export type UpdateOrganizationQuotePresetMutationVariables = Exact<{
  orgId: Scalars['ID'];
  menuId: Scalars['String'];
  quotePresets: QuotePresetsUpdateInput;
}>;


export type UpdateOrganizationQuotePresetMutationResult = { __typename?: 'Mutation', updateOrganizationQuotePreset: { __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, path: string | null, isArchived: boolean | null, activeMembers: number | null, quotePresets: Array<{ __typename?: 'OrganizationQuotePreset', menuId: string, patchRequirement: any | null }> } };

export type DeleteOrganizationQuotePresetMutationVariables = Exact<{
  orgId: Scalars['ID'];
  quotePresetId: Scalars['Int'];
}>;


export type DeleteOrganizationQuotePresetMutationResult = { __typename?: 'Mutation', deleteOrganizationQuotePreset: { __typename?: 'Organization', id: string, refId: string, name: string, legalName: string | null, path: string | null, isArchived: boolean | null, activeMembers: number | null, quotePresets: Array<{ __typename?: 'OrganizationQuotePreset', menuId: string, patchRequirement: any | null }> } };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQueryResult = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'AvailableBalance', id: string, type: string, availableBalance: number } | { __typename?: 'BankAccount', id: string, type: string, bankName: string, last4: string, status: string, accountHolderName: string } | { __typename?: 'MSTS', id: string, type: string, status: string, creditLimit: number, creditUsed: number, creditHeld: number, businessName: string } | { __typename?: 'StripeCard', id: string, type: string, brand: string, expMonth: string, expYear: string, last4: string, name: string | null } | null> };

export type GetLinkTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLinkTokenQueryResult = { __typename?: 'Query', getLinkToken: { __typename?: 'LinkTokenResponse', token: string } };

export type PaymentActionsByCheckoutIdentifierQueryVariables = Exact<{
  checkoutIdentifier: Scalars['String'];
}>;


export type PaymentActionsByCheckoutIdentifierQueryResult = { __typename?: 'Query', authorizationsByCheckoutIdentifier: Array<{ __typename?: 'Authorization', amount: number, methodType: string, methodId: string, createdAt: any | null, successful: boolean | null, paymentMethod: { __typename?: 'AvailableBalance', id: string, type: string, availableBalance: number } | { __typename?: 'BankAccount', id: string, type: string, bankName: string, last4: string, status: string, accountHolderName: string } | { __typename?: 'MSTS', id: string, type: string, status: string, creditLimit: number, creditUsed: number, creditHeld: number, businessName: string } | { __typename?: 'StripeCard', id: string, type: string, brand: string, expMonth: string, expYear: string, last4: string, name: string | null } | null }> | null, captures: Array<{ __typename?: 'Capture', amount: number, methodType: string, methodId: string, createdAt: any | null, successful: boolean | null, paymentMethod: { __typename?: 'AvailableBalance', id: string, type: string, availableBalance: number } | { __typename?: 'BankAccount', id: string, type: string, bankName: string, last4: string, status: string, accountHolderName: string } | { __typename?: 'MSTS', id: string, type: string, status: string, creditLimit: number, creditUsed: number, creditHeld: number, businessName: string } | { __typename?: 'StripeCard', id: string, type: string, brand: string, expMonth: string, expYear: string, last4: string, name: string | null } | null }> | null };

export type AddStripeCardMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type AddStripeCardMutationResult = { __typename?: 'Mutation', addStripeCard: { __typename?: 'AvailableBalance' } | { __typename?: 'BankAccount' } | { __typename?: 'MSTS' } | { __typename?: 'StripeCard', id: string } };

export type RemoveStripeCardMutationVariables = Exact<{
  cardId: Scalars['String'];
}>;


export type RemoveStripeCardMutationResult = { __typename?: 'Mutation', removeStripeCard: { __typename?: 'RemoveStripeCardMutationResponse', code: string, success: boolean, message: string } };

export type AddBankAccountMutationVariables = Exact<{
  token: Scalars['String'];
  accountIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AddBankAccountMutationResult = { __typename?: 'Mutation', addBankAccount: { __typename?: 'AvailableBalance' } | { __typename?: 'BankAccount', id: string } | { __typename?: 'MSTS' } | { __typename?: 'StripeCard' } };

export type RemoveBankAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type RemoveBankAccountMutationResult = { __typename?: 'Mutation', removeBankAccount: { __typename?: 'RemoveBankAccountMutationResponse', code: string, success: boolean, message: string } };

export type CheckoutMutationVariables = Exact<{
  checkoutIdentifier: Scalars['String'];
  paymentMethodId: Scalars['ID'];
  paymentMethodType: Scalars['String'];
  lineItems: Array<PaymentCaptureLineItemInput> | PaymentCaptureLineItemInput;
  amount: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  callbackMutation: InputMaybe<Scalars['String']>;
}>;


export type CheckoutMutationResult = { __typename?: 'Mutation', checkout: { __typename?: 'CheckoutPaymentReturn', successful: boolean } };

export type UploadPaymentFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  acls: Array<PaymentFileAcl> | PaymentFileAcl;
  bucket: InputMaybe<PaymentFileS3Bucket>;
  userFileAttributes: InputMaybe<Scalars['String']>;
}>;


export type UploadPaymentFileMutationResult = { __typename?: 'Mutation', uploadPaymentFile: { __typename?: 'PaymentFile', id: number } };

export type UploadPaymentFilesMutationVariables = Exact<{
  files: Array<Scalars['Upload']> | Scalars['Upload'];
  acls: Array<PaymentFileAcl> | PaymentFileAcl;
  bucket: InputMaybe<PaymentFileS3Bucket>;
  userFileAttributes: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type UploadPaymentFilesMutationResult = { __typename?: 'Mutation', uploadPaymentFiles: Array<{ __typename?: 'PaymentFile', id: number }> };

export type GetBillingAccountUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetBillingAccountUserQueryResult = { __typename?: 'Query', getBillingAccountUser: { __typename?: 'User', billingAccounts: { __typename?: 'UserBillingAccountConnection', edges: Array<{ __typename?: 'UserBillingAccountEdge', node: { __typename?: 'BillingAccount', id: string, createdBy: string | null, name: string, creditLimitInCents: number, availableCreditInCents: number | null, creditTerm: string | null, status: BillingAccountStatus | null, contact: { __typename?: 'BillingAccountContact', name: string, phoneNumber: string, emailAddress: string, address: { __typename?: 'BillingAccountAddress', street1: string, street2: string | null, city: string, state: string | null, province: string | null, zipcode: string | null, country: string } | null } | null } | null } | null> | null } | null } | null };

export type GetTaxExemptionsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetTaxExemptionsQueryResult = { __typename?: 'Query', getTaxExemptions: Array<{ __typename?: 'TaxExemption', id: string, client_id: string | null, billingAccountId: string, pdfUrl: string | null, filename: string | null, expiration_date: any | null, signed_date: any | null, billingAccountName: string | null, document_type: { __typename?: 'TaxExemptionSubObject', name: string | null } | null, actual_tax_code: { __typename?: 'TaxExemptionSubObject', name: string | null } | null, expected_tax_code: { __typename?: 'TaxExemptionSubObject', name: string | null } | null, exposure_zone: { __typename?: 'TaxExemptionSubObject', name: string | null } | null, status: { __typename?: 'TaxExemptionStatus', name: string | null } | null } | null> | null };

export type PartnerByUserIdQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type PartnerByUserIdQueryResult = { __typename?: 'Query', partnerByUserId: { __typename?: 'PartnerByUserId', partner: { __typename?: 'Partner', id: string } | null } | null };

export type HasUserSubmittedApplicationQueryVariables = Exact<{
  billingAccountId: Scalars['String'];
}>;


export type HasUserSubmittedApplicationQueryResult = { __typename?: 'Query', hasUserSubmittedApplication: { __typename?: 'UserSubmittedApplication', isSubmitted: boolean | null, date: any | null } | null };

export type UserByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserByIdQueryResult = { __typename?: 'Query', userById: { __typename?: 'User', firstName: string | null, lastName: string | null, emailAddress: string | null, id: string, registered: boolean | null } | null };

export type GetLoggedInUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoggedInUserQueryResult = { __typename?: 'Query', me: { __typename?: 'SessionUser', firstName: string | null, lastName: string | null, emailAddress: string | null, id: string, registered: boolean | null } | null };

export type UserInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInvitationsQueryResult = { __typename?: 'Query', userInvitations: Array<{ __typename?: 'UserInvitation', inviteUrl: string, partnerName: string, inviterEmail: string | null }> };

export type GetBillingAccountFinancialsQueryVariables = Exact<{
  input: GetBillingAccountInput;
}>;


export type GetBillingAccountFinancialsQueryResult = { __typename?: 'Query', getBillingAccount: { __typename?: 'BillingAccount', id: string, name: string, invoices: Array<{ __typename?: 'IntacctInvoice', recordNo: number, docNo: string, whenCreated: any, whenDue: any, totalEntered: string, totalDue: string, state: string, currency: string, paymentProcessingStatus: string | null }>, payments: Array<{ __typename?: 'IntacctPayment', recordNo: number, customerId: string, whenCreated: any, totalEntered: string, unusedAmount: string, currency: string, allocations: Array<{ __typename?: 'IntacctPaymentAllocation', invoiceRecordNo: string, amountApplied: string }> }>, creditMemos: Array<{ __typename?: 'IntacctCreditMemo', recordNo: number, docNo: string | null, whenCreated: any, totalEntered: string | null, totalDue: string, state: string, currency: string | null, description: string | null }> | null } | null };

export type PayInvoicesMutationVariables = Exact<{
  input: InvoicePaymentInput;
}>;


export type PayInvoicesMutationResult = { __typename?: 'Mutation', payInvoices: { __typename?: 'InvoicePaymentResult', successful: boolean, chargeId: string | null, errorMessage: string | null } };

export type UserAcceptTosMutationVariables = Exact<{
  id: Scalars['ID'];
  vendor: InputMaybe<Scalars['Boolean']>;
}>;


export type UserAcceptTosMutationResult = { __typename?: 'Mutation', userAcceptTos: string | null };

export type IsEmailInAuth0QueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsEmailInAuth0QueryResult = { __typename?: 'Query', isEmailInAuth0: boolean | null };
